import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import logo from './assets/images/logo.png';
import { Route, Link, BrowserRouter as Router } from 'react-router-dom';
import './assets/dist/css/bootstrap.css';
import './assets/css/style.css';
import './assets/css/rfs.css';
import * as myConstClass from './constant.js';
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { stateToHTML } from 'draft-js-export-html';
import NewHeader from './newHeader.js';
import Footer from './Footer.js';
import { Editor } from 'react-draft-wysiwyg';
import $ from 'jquery';
import checkoutImage from './assets/images/mycart.png';
import { Helmet } from "react-helmet";
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import ReCAPTCHA from "react-google-recaptcha";

// Translation Higher Order Component
import {
  setTranslations,
  setDefaultLanguage,
  setLanguageCookie,
  setLanguage, getLanguage,
  translate,
} from 'react-switch-lang';
import en from './en.json';
import ma from './ma.json';
import PropTypes from 'prop-types';

import {
  Row,
  Col,
  Label
} from 'reactstrap';

// Guest cart and order helpers
import { prepareGuestOrderData, savePendingGuestOrder } from './utils/guestOrderHelpers.js';

class Checkout extends Component {
    componentDidMount() {
        // For guests, load machine tests and events into state for display
        const user_id = localStorage.getItem('user_id');
        const guest_user_id = localStorage.getItem('guest_user_id_temp');
        const effective_user_id = user_id || guest_user_id;
        if (!effective_user_id || effective_user_id <= 0) {
          const guestEvents = JSON.parse(localStorage.getItem('guest_cart_events') || '[]');
          const guestMachineTests = JSON.parse(localStorage.getItem('guest_mt_cart') || '[]');
          // Always wrap machine tests in expected structure for rendering
          const formattedMachineTests = guestMachineTests.length > 0 ? [{ event_type: 'Machine Test', arr_cart: guestMachineTests }] : [];
          this.setState({
            cartEvent: guestEvents,
            cartMachineTestEvent: formattedMachineTests
          });
        }
    }
  constructor(props) {
    super(props);
    this.recaptchaRef = React.createRef();
    this.product_id = 0;
    this.state = {
      languagePdf: '',
      cart: [],
      arrMagazine: [],
      flag: 0,
      language: 'en',
      value: 1,
      eventinfoarray: [],
      guestinfoarray: [],
      cartEvent: [],
      cartMachineTestEvent: [],
      bookingEvent: null, // NEW: Event booking from localStorage (booking_event or booking_event_guest)
      delivery_type: '1',
      magazineinfo: {
        totalMagazinePrice: 0,
        // totalMagazinePriceNew:0,
      },
      termsinfo: {
        description_html: '',
        description_mr_html: '',
        description: '',
      },
      guestinfo: {
        first_name: '',
        middle_name: '',
        last_name: '',
        address_line_1: '',
        address_line_2: '',
        landmark: '',
        country: '',
        state: '',
        city: '',
        pincode: '',
        phone: '',
        email: '',
        country_name: '',
        state_name: '',
        city_name: '',
        product_total_price: '',
        // totalMagazinePrice:0,
        total_shipping_charges: 0,
        total_shipping_charges_express: 0,
        country_id: '',
        shipping_message: '',
        total_weight_in_kg: '',
        country_name: '',
      },
      eventinfo: {
        first_name_shipping: '',
        middle_name: '',
        last_name: '',
        address_line_1: '',
        address_line_2: '',
        landmark: '',
        country: '',
        state: '',
        city: '',
        pincode: '',
        phone: '',
        email: '',
        country_name: '',
        state_name: '',
        cart_total_price: '',
        //totalMagazinePrice:'',


      },

      removeinfo: {
        message: '',
        status: '',
        encrypted_data: '',
        access_code: '',

      },
      cartTotal: {
        message: '',
        status: '',
        cart_total_price: '',
      },
      editorState: EditorState.createEmpty(),
      isProcessingPayment: false
    }

    this.handleChange = this.handleChange.bind(this);
    //this.removeFromCart = this.removeFromCart.bind(this);
    this.proceedToPayment = this.proceedToPayment.bind(this);
    this.handleChangeDelivery = this.handleChangeDelivery.bind(this);
    this.getTotal = this.getTotal.bind(this);
    this.cartTotalPrice = this.cartTotalPrice.bind(this);
    this.transferGuestCartToUser = this.transferGuestCartToUser.bind(this);
    // this.checkout = this.checkout.bind(this);
    this.changeArrowDirection = this.changeArrowDirection.bind(this);
  this.onRecaptchaChange = this.onRecaptchaChange.bind(this);
  this.state.recaptchaToken = null;
  }

  onRecaptchaChange(value) {
    // console.log("reCAPTCHA v2 completed! Token:", value ? 'Received (length: ' + value.length + ')' : 'Null');
    // Only use React state for token, never localStorage/global
    if (value && typeof value === 'string' && value.length >= 10) {
      this.setState({ recaptchaToken: value });
      toast('reCAPTCHA verified successfully!', { 
        containerId: 'B', 
        type: toast.TYPE.SUCCESS,
        autoClose: 2000
      });
    } else {
      this.setState({ recaptchaToken: null });
      // If token is lost or expired, reset widget
      if (this.recaptchaRef.current && typeof this.recaptchaRef.current.reset === 'function') {
        this.recaptchaRef.current.reset();
      }
    }
  }

  // Format date to match EventScheduleCard display (e.g. "Mon, Jan 01, 2025")
  formatDateForSchedule(dateStr) {
    if (!dateStr) return '';

    // If already looks formatted (contains letters or comma), return as-is
    if (/[a-zA-Z,]/.test(dateStr)) return dateStr;

    // Accept YYYY-MM-DD or DD-MM-YYYY
    // YYYY-MM-DD -> new Date(dateStr)
    // DD-MM-YYYY -> split and build
    let d = null;
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
      d = new Date(dateStr);
    } else if (/^\d{2}-\d{2}-\d{4}$/.test(dateStr)) {
      const [day, month, year] = dateStr.split('-');
      d = new Date(parseInt(year, 10), parseInt(month, 10) - 1, parseInt(day, 10));
    } else {
      // Try Date parse as fallback
      const parsed = Date.parse(dateStr);
      if (!Number.isNaN(parsed)) d = new Date(parsed);
    }

    if (!d || Number.isNaN(d.getTime())) return dateStr;

    return d.toLocaleDateString('en-US', { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' });
  }

  getTotal() {
    if (this.state.arrMagazine.length > 0) {
      return this.state.arrMagazine[0].total_donation_contribution;
    } else {
      return 0;
    }

  }

  updateGuestShippingFallback(subtotal, countryId, stateId, guestProducts) {
    // Fallback shipping calculation if API call fails
    // console.log('Fallback shipping calculation...');
    
    let totalWeight = guestProducts.reduce((sum, product) => {
      const productWeight = parseFloat(product.weight || product.product_weight || 0);
      const quantity = parseInt(product.quantity || 1);
      return sum + (productWeight * quantity);
    }, 0);
    
    let fallbackShipping = 50; // Default
    if (totalWeight > 0) {
      if (totalWeight <= 1) fallbackShipping = 50;
      else if (totalWeight <= 2) fallbackShipping = 75;
      else if (totalWeight <= 5) fallbackShipping = 100;
      else fallbackShipping = 150;
    }
    
    const fallbackShippingExpress = fallbackShipping * 2;
    const totalWithShipping = subtotal + fallbackShipping;
    
    this.setState({
      cartTotal: { cart_total_price: totalWithShipping },
      guestinfo: {
        ...this.state.guestinfo,
        total_shipping_charges: fallbackShipping,
        total_shipping_charges_express: fallbackShippingExpress,
        total_weight_in_kg: totalWeight || 0.5,
        shipping_message: '(Estimated)'
      },
      eventinfo: {
        ...this.state.eventinfo,
        cart_total_price: totalWithShipping.toFixed(2)
      }
    });
    
    localStorage.setItem('cart_total_price', totalWithShipping.toFixed(2));
    
    if (countryId == 101 && totalWeight > 0) {
      $('#total_shipping_charges_express_row').css('display', 'flex');
    }
    
    // console.log('Fallback shipping applied:', {
    //   weight: totalWeight,
    //   regular: fallbackShipping,
    //   express: fallbackShippingExpress
    // });
  }

  cartTotalPrice() {
    if (this.state.eventinfo.cart_total_price > 0) {
      var regular_shipping_charges = this.state.guestinfo.total_shipping_charges;
      var total_price = this.state.eventinfo.cart_total_price;
      //  return (parseFloat(total_price) + parseFloat(regular_shipping_charges));
      return total_price;
    } else {
      return 0;
    }

  }

  handleChangeDelivery(event) {
    this.setState({
      delivery_type: event.target.value
    });

    var user_id = localStorage.getItem('user_id');
    var guest_user_id = localStorage.getItem('guest_user_id_temp');
    var effective_user_id = user_id || guest_user_id;
    
    // Get shipping charges
    var regular_shipping_charges = this.state.guestinfo.total_shipping_charges || 0;
    var express_shipping_charges = this.state.guestinfo.total_shipping_charges_express || 0;
    
    if (!effective_user_id || effective_user_id <= 0) {
      // Guest user: Calculate total with shipping charges and set state for display
      const guestProducts = JSON.parse(localStorage.getItem('guest_cart_products') || '[]');
      const guestMagazines = JSON.parse(localStorage.getItem('guest_cart_magazines') || '[]');
      const guestEvents = JSON.parse(localStorage.getItem('guest_cart_events') || '[]');
      const guestMachineTests = JSON.parse(localStorage.getItem('guest_mt_cart') || '[]');
      // Calculate subtotal (products + magazines + events + machine tests)
      const productTotal = guestProducts.reduce((sum, product) => 
        sum + (parseFloat(product.price || 0) * parseInt(product.quantity || 1)), 0);
      const magazineTotal = guestMagazines.reduce((sum, mag) => 
        sum + parseFloat(mag.donation_contribution || mag.price || 0), 0);
      const eventTotal = guestEvents.reduce((sum, event) => {
        const parentPrice = parseFloat(event.price || 0) * parseInt(event.parent || 0);
        const childPrice = parseFloat(event.child_price || event.price || 0) * parseInt(event.child || 0);
        return sum + parentPrice + childPrice;
      }, 0);
      const machineTestTotal = guestMachineTests.reduce((sum, mt) => {
        const parentPrice = parseFloat(mt.price || 0) * parseInt(mt.parent || 0);
        const childPrice = parseFloat(mt.child_price || mt.price || 0) * parseInt(mt.child || 0);
        return sum + parentPrice + childPrice;
      }, 0);
      const subtotal = productTotal + magazineTotal + eventTotal + machineTestTotal;

      // Set state for display of selected items
      this.setState({
        cartEvent: guestEvents,
        cartMachineTestEvent: guestMachineTests
      });

    if (event.target.value == 1) {
        // Regular shipping
        var shipping_charges = this.state.guestinfo.total_shipping_charges;
        const newTotal = (parseFloat(subtotal) + parseFloat(shipping_charges)).toFixed(2);
        this.setState({ 
          eventinfo: { ...this.state.eventinfo, cart_total_price: newTotal },
          cartTotal: { cart_total_price: parseFloat(subtotal) + parseFloat(shipping_charges) }
        });
        localStorage.setItem('cart_total_price', newTotal);
      } else {
        // Express shipping
        var shipping_charges = this.state.guestinfo.total_shipping_charges_express;
        const newTotal = (parseFloat(subtotal) + parseFloat(shipping_charges)).toFixed(2);
        this.setState({ 
          eventinfo: { ...this.state.eventinfo, cart_total_price: newTotal },
          cartTotal: { cart_total_price: parseFloat(subtotal) + parseFloat(shipping_charges) }
        });
        localStorage.setItem('cart_total_price', newTotal);
      }
    } else {
      // Logged-in user: Use cartTotal from API
      var current_cart_total_price = this.state.cartTotal.cart_total_price;

      if (event.target.value == 1) {
        // Regular shipping (already included in cartTotal from API)
        const newTotal = (parseFloat(current_cart_total_price)).toFixed(2);
        this.setState({ eventinfo: { ...this.state.eventinfo, cart_total_price: newTotal } });
        localStorage.setItem('cart_total_price', newTotal);
    } else {
        // Express shipping (add difference between express and regular)
      var regular_shipping_charges = this.state.guestinfo.total_shipping_charges;
      var express_shipping_charges = this.state.guestinfo.total_shipping_charges_express;
        const newTotal = (parseFloat(current_cart_total_price) + parseFloat(express_shipping_charges) - parseFloat(regular_shipping_charges)).toFixed(2);
        this.setState({ eventinfo: { ...this.state.eventinfo, cart_total_price: newTotal } });
        localStorage.setItem('cart_total_price', newTotal);
      }
    }

  }

  async handleGuestPayment() {
    // First create guest user account, then proceed with payment
    // console.log('Creating guest user account before payment...');
    
    try {
      // Step 1: Create guest user account
      const guestUserData = await this.createGuestUserAccount();
      
      if (!guestUserData || !guestUserData.user_id) {
        throw new Error('Email already registered, please log in or use another email');
      }
      
      // console.log('Guest user account created successfully:', guestUserData);
      
      // Step 2: Save billing and shipping addresses to database
      await this.saveGuestAddressesToDB(guestUserData.user_id);
      
      // Step 3: Transfer guest cart to newly created user account
      await this.transferGuestCartToUser(guestUserData.user_id);
      
      // Step 4: Proceed with payment using the new user_id
      await this.proceedWithPayment(guestUserData.user_id);
      
    } catch (error) {
      $('#btn_click').css('display', 'inline');
      $('#loader').css('display', 'none');
      toast('Payment error. Please try again.', { 
        containerId: 'B', 
        type: toast.TYPE.ERROR 
      });
    }
  }

  async createGuestUserAccount() {
    // Get guest address details
    const guestBillingArray = JSON.parse(localStorage.getItem('guest_billing_address') || '[]');
    const guestShippingArray = JSON.parse(localStorage.getItem('guest_shipping_address') || '[]');
    
    // Convert to objects
    const guestBilling = {};
    guestBillingArray.forEach(item => {
      guestBilling[item.name] = item.value;
    });
    
    const guestShipping = {};
    guestShippingArray.forEach(item => {
      guestShipping[item.name] = item.value;
    });
    
    // Prepare guest user registration data - only essential fields for account creation
    const guestUserData = {
      userType: "guest",
      first_name: guestBilling.first_name || guestShipping.shipping_first_name || '',
      last_name: guestBilling.last_name || guestShipping.shipping_last_name || '',
      email: guestBilling.email || guestShipping.shipping_email || '',
      phone: guestBilling.phone || guestShipping.shipping_phone || ''
    };
    
    // console.log('Creating guest user with data:', guestUserData);
    
    const response = await fetch(`${myConstClass.NODE_API_BASE}/auth/register`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(guestUserData)
    });
    
    const result = await response.json();
    // console.log('Guest user creation response:', result);
    
    if (result.status === 'true' && result.user_details && result.user_details.userId) {
      // Store the new user_id temporarily for this session
      const userId = result.user_details.userId;
      localStorage.setItem('temp_guest_user_id', userId);
      return { user_id: userId, ...result };
    } else {
      throw new Error(result.message || 'Email already registered, please log in or use another email');
    }
  }

  async saveGuestAddressesToDB(user_id) {
    // Save billing and shipping addresses to database after account creation
    const guestBillingArray = JSON.parse(localStorage.getItem('guest_billing_address') || '[]');
    const guestShippingArray = JSON.parse(localStorage.getItem('guest_shipping_address') || '[]');
    
    // console.log('Saving guest addresses to database for user:', user_id);
    
    // Convert to objects
    const guestBilling = {};
    guestBillingArray.forEach(item => {
      guestBilling[item.name] = item.value;
    });
    
    const guestShipping = {};
    guestShippingArray.forEach(item => {
      guestShipping[item.name] = item.value;
    });
    
    // Save billing address (address_type = 1)
    const billingData = {
      first_name: guestBilling.first_name || '',
      middle_name: guestBilling.middle_name || '',
      last_name: guestBilling.last_name || '',
      company: guestBilling.company || '',
      address_line_1: guestBilling.address_line_1 || '',
      address_line_2: guestBilling.address_line_2 || '',
      landmark: guestBilling.landmark || '',
      country: guestBilling.country || '101',
      state: guestBilling.state || '',
      city: guestBilling.city || '',
      pincode: guestBilling.pincode || '',
      phone: guestBilling.phone || '',
      email: guestBilling.email || ''
    };
    
    // Save shipping address (address_type = 2)
    const shippingData = {
      first_name: guestShipping.shipping_first_name || guestBilling.first_name || '',
      middle_name: guestShipping.shipping_middle_name || guestBilling.middle_name || '',
      last_name: guestShipping.shipping_last_name || guestBilling.last_name || '',
      company: guestShipping.shipping_company || guestBilling.company || '',
      address_line_1: guestShipping.shipping_address_line_1 || guestBilling.address_line_1 || '',
      address_line_2: guestShipping.shipping_address_line_2 || guestBilling.address_line_2 || '',
      landmark: guestShipping.shipping_landmark || guestBilling.landmark || '',
      country: guestShipping.shipping_country || guestBilling.country || '101',
      state: guestShipping.shipping_state || guestBilling.state || '',
      city: guestShipping.shipping_city || guestBilling.city || '',
      pincode: guestShipping.shipping_pincode || guestBilling.pincode || '',
      phone: guestShipping.shipping_phone || guestBilling.phone || '',
      email: guestShipping.shipping_email || guestBilling.email || ''
    };
    
    try {
      // Save billing address
      await fetch(myConstClass.BASE_URL + `users/addAddress/1/${user_id}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(billingData)
      });
      
      // Save shipping address
      await fetch(myConstClass.BASE_URL + `users/addAddress/2/${user_id}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(shippingData)
      });
      
      // console.log('Guest addresses saved successfully');
    } catch (error) {
      throw error;
    }
  }

  async transferGuestCartToUser(user_id) {
    // Transfer guest cart items to the newly created user account
    const guestProducts = JSON.parse(localStorage.getItem('guest_cart_products') || '[]');
    const guestMagazines = JSON.parse(localStorage.getItem('guest_cart_magazines') || '[]');
    const guestEvents = JSON.parse(localStorage.getItem('guest_cart_events') || '[]');
    
    // console.log('Transferring guest cart to user:', user_id);
    // console.log('Products to transfer:', guestProducts.length);
    // console.log('Magazines to transfer:', guestMagazines.length);
    // console.log('Events to transfer:', guestEvents.length);
    
    try {
      // Transfer products
      if (guestProducts.length > 0) {
        for (const product of guestProducts) {
          const response = await fetch(myConstClass.BASE_URL + `cart/addProductToCart/${product.product_id}/${product.quantity}/${user_id}`, {
            method: 'GET'  // Changed from POST to GET to match backend
          });
          const result = await response.json();
          // console.log(`Product ${product.product_id} transfer result:`, result);
          if (result.status !== 'true') {
          }
        }
      }
      
      // Transfer magazines
      if (guestMagazines.length > 0) {
        for (const magazine of guestMagazines) {
          const response = await fetch(myConstClass.BASE_URL + `cart/addMagazineToCart/${magazine.package_id}/${user_id}`, {
            method: 'GET'  // Changed from POST to GET to match backend
          });
          const result = await response.json();
          // console.log(`Magazine ${magazine.package_id} transfer result:`, result);
          if (result.status !== 'true') {
          }
        }
      }
      
      // Transfer events (machine tests stay in localStorage)
      if (guestEvents.length > 0) {
        for (const event of guestEvents) {
          // Check if this is a machine test event
          if (event.event_type === 'Machine Test' || event.event_type_id === 3) {
            // Machine tests now use localStorage for both guest and logged-in users
            // No backend transfer needed - they'll be processed from localStorage during checkout
            // console.log(`Machine Test Event ${event.event_id} - staying in localStorage`);
          } else {
            // Use regular event API
            const response = await fetch(myConstClass.BASE_URL + `cart/addEventToCart/${event.schedule_id}/${user_id}/${event.parent}/${event.child || 0}`, {
              method: 'GET'
            });
            const result = await response.json();
           // console.log(`Event ${event.schedule_id} transfer result:`, result);
            if (result.status !== 'true') {
            }
          }
        }
      }
      
      // console.log('Guest cart transfer completed');
    } catch (error) {
      throw new Error('Failed to transfer cart items: ' + error.message);
    }
  }

  async proceedWithPayment(user_id) {
    // Proceed with payment using the newly created user account
    const total_price = this.state.cartTotal.cart_total_price;
    const is_same_address = localStorage.getItem('is_same_address');
    const delivery_type = $("input[name='delivery_type']:checked").val();
    const total_shipping_charges = delivery_type == 1 ? 
      this.state.guestinfo.total_shipping_charges : 
      this.state.guestinfo.total_shipping_charges_express;
    
    // console.log('Proceeding with payment for user:', user_id);
    
    const response = await fetch(myConstClass.BASE_URL + `payment/goToPayment/` + user_id + '/' + is_same_address + '/' + delivery_type + '/' + total_shipping_charges, {
      method: 'POST',
      body: JSON.stringify($('#captcha').serializeArray()),
    });
    
    const result = await response.json();
      // console.log('Payment response:', result);
    
    this.setState({ removeinfo: result });
    const message = this.state.removeinfo.message;
    const status = this.state.removeinfo.status;
    const order_id = this.state.removeinfo.order_id;
    
    if (status == 'true') {
      $('#btn_click').css('display', 'inline');
      $('#loader').css('display', 'none');
      
      // Debug: Log payment response data
      // console.log('Payment API Response:', result);
      // console.log('Order ID:', order_id);
      // console.log('Encrypted Data:', this.state.removeinfo.encrypted_data);
      // console.log('Access Code:', this.state.removeinfo.access_code);
      
      // Validate required fields before redirect (order_id may be null for some gateways)
      if (!this.state.removeinfo.encrypted_data || !this.state.removeinfo.access_code) {
        toast('Payment data incomplete. Please try again.', { 
          containerId: 'B', 
          type: toast.TYPE.ERROR 
        });
        return;
      }
      if (!order_id) {
      }
      
      this.state.removeinfo.encrypted_data = this.state.removeinfo.encrypted_data;
      this.state.removeinfo.access_code = this.state.removeinfo.access_code;

      // For guest users: save order data before clearing cart
      const user_id = localStorage.getItem('user_id');
      const guest_user_id = localStorage.getItem('guest_user_id_temp');
      
      // Check if this is a guest user (has guest_user_id but no user_id)
      if (!user_id && guest_user_id) {
        // console.log('Preparing guest order data before payment...');
        const guestOrderData = prepareGuestOrderData();
        if (guestOrderData && guestOrderData.billing_address && guestOrderData.billing_address.email) {
          guestOrderData.order_id = this.state.removeinfo.order_id;
          guestOrderData.order_id_main = this.state.removeinfo.order_id; // Backend returns database ID only
          savePendingGuestOrder(guestOrderData);
          // console.log('Guest order data saved, will be completed after payment success');
        } else {
        }
      }
      // Do NOT clear guest cart/address data here. It will be cleared after order is finalized in Orderdetails.js

      // Add small delay to ensure state is updated before form submission
      setTimeout(() => {
        // console.log('Submitting payment form to CCAvenue...');
        $("#redirect").submit();
      }, 100);
    } else {
      $('#btn_click').css('display', 'inline');
      $('#loader').css('display', 'none');
      toast(message || 'Payment failed. Please try again.', { 
        containerId: 'B', 
        type: toast.TYPE.ERROR 
      });
    }
  }

  async proceedToPayment(e) {
    this.setState({ isProcessingPayment: true });
    e.preventDefault();
    // Verify reCAPTCHA v2 with detailed debugging
    // console.log('=== reCAPTCHA Validation Start ===');
    // console.log('1. recaptchaRef:', this.recaptchaRef);
    // console.log('2. recaptchaRef.current:', this.recaptchaRef.current);
    if (!this.recaptchaRef.current) {
      toast('reCAPTCHA not loaded properly. Please refresh the page.', { 
        containerId: 'B', 
        type: toast.TYPE.ERROR 
      });
      return;
    }
    const recaptchaValue = this.state.recaptchaToken;
    // console.log('3. getValue() result:', recaptchaValue);
    // console.log('4. Token length:', recaptchaValue ? recaptchaValue.length : 0);
    // console.log('5. Token type:', typeof recaptchaValue);
    // console.log('=== reCAPTCHA Validation End ===');
    // Check for token expiry (token should be a non-empty string)
    if (!recaptchaValue || typeof recaptchaValue !== 'string' || recaptchaValue.length < 10) {
      toast('Please confirm you are not a robot. Solve reCAPTCHA again.', { 
        containerId: 'B', 
        type: toast.TYPE.ERROR 
      });
      // Reset reCAPTCHA widget so user can solve again
      if (this.recaptchaRef.current && typeof this.recaptchaRef.current.reset === 'function') {
        this.recaptchaRef.current.reset();
      }
      this.setState({ recaptchaToken: null });
      return;
    }

    var delivery_type = $("input[name='delivery_type']:checked").val();
    if (delivery_type == 1) {
      var total_shipping_charges = this.state.guestinfo.total_shipping_charges;
    } else {
      var total_shipping_charges = this.state.guestinfo.total_shipping_charges_express;
    }

    $('#btn_click').css('display', 'none');
    $('#loader').css('display', 'inline');
    
    // Check for both logged-in user OR auto-created guest user
    var user_id = localStorage.getItem('user_id');
    var guest_user_id = localStorage.getItem('guest_user_id_temp');
    var effective_user_id = user_id || guest_user_id;
    
    // Get cart total - IMPORTANT: Recalculate to include machine tests from localStorage
    let total_price = this.state.cartTotal.cart_total_price;
    
    // For users (logged-in or guest) with machine tests in localStorage, recalculate total
    // Check both guest_mt_cart (primary) and guest_cart_events (backup) for machine tests
    const guestMachineTests = JSON.parse(localStorage.getItem('guest_mt_cart') || '[]');
    const guestEvents = JSON.parse(localStorage.getItem('guest_cart_events') || '[]');
    const machineTestEvents = guestEvents.filter(e => e.event_type === 'Machine Test' || e.event_type_id === 3);
    
    // Combine machine tests from both sources
    const allMachineTests = [...guestMachineTests, ...machineTestEvents];
    
    if (allMachineTests.length > 0) {
      // Recalculate machine test total
      const machineTestTotal = allMachineTests.reduce((sum, event) => {
        const parentPrice = parseFloat(event.first_price || event.price || 0) * parseInt(event.parent || 0);
        const childPrice = parseFloat(event.second_price || event.child_price || event.first_price || 0) * parseInt(event.child || 0);
        return sum + parentPrice + childPrice;
      }, 0);
      
      // Get backend cart total (products/magazines)
      const backendTotal = parseFloat(localStorage.getItem('cart_total_price') || this.state.cartTotal.cart_total_price || 0);
      
      // Calculate actual total including machine tests
      total_price = backendTotal + machineTestTotal;
    }
    
    // NEW FLOW: Guest accounts are created on address page!
    // By the time users reach checkout, they ALL have a user_id (logged-in OR auto-created guest)
    // So the payment flow is IDENTICAL for both user types!
    
    if (!effective_user_id || effective_user_id <= 0) {
      // EDGE CASE: Should not happen in normal flow (address page creates account)
      // But keep as fallback for direct URL access
      toast.error('Please complete the address step first', { containerId: 'B' });
      this.props.history.push('/address');
      return;
    }
    
    // Proceed with payment (for BOTH logged-in users AND auto-created guest users)
    // Check if this is an event booking (separate flow from cart)
    const bookingEvent = localStorage.getItem('booking_event') || localStorage.getItem('booking_event_guest');
    
    if (bookingEvent && effective_user_id != '' && effective_user_id > 0) {
      // EVENT BOOKING FLOW: Use Node.js API endpoints (separate from cart)
      try {
        const bookingEventData = JSON.parse(bookingEvent);
        // console.log('🎫 Event booking detected - using Node.js event booking API:', bookingEventData);
          
          // Get participants data
          let participants = [];
          
          if (!user_id || user_id <= 0) {
            // Guest user: Get from localStorage
            const guestEventParticipants = JSON.parse(localStorage.getItem('guest_event_participants') || '{}');
            const eventKey = bookingEventData.schedule_id ? `schedule_${bookingEventData.schedule_id}` : `event_${bookingEventData.event_id}`;
            const savedParticipants = guestEventParticipants[eventKey] || [];
            
            const firstPriceFor = (bookingEventData.first_price_for || 'person').toLowerCase();
            const secondPriceFor = bookingEventData.second_price_for ? bookingEventData.second_price_for.toLowerCase() : null;
            
            // Format participants for API (backend expects snake_case)
            participants = savedParticipants.map(p => ({
              first_name: p.first_name || p.participate_first_name || '',
              last_name: p.last_name || p.participate_last_name || '',
              email: p.email || p.participate_email || '',
              mobile: p.mobile || p.participate_mobile || '',
              date_of_birth: p.date_of_birth || p.birth_date || '',
              gender: p.gender || p.participate_gender || '',
              type: (p.participant_type || '').toLowerCase() === secondPriceFor ? secondPriceFor : firstPriceFor
            }));
          } else {
            // Logged-in user: Fetch participants from Node API and filter to selected ones
            try {
              const nodeApiBase = myConstClass.NODE_API_BASE || myConstClass.BASE_URL.replace('/index.php/', '/api');
              const participantsUrl = `${nodeApiBase}/participants/getUserParticipants/${effective_user_id}`;
              
              // console.log('Fetching participants from Node API:', participantsUrl);
              
              const participantsResponse = await fetch(participantsUrl);
              const participantsResult = await participantsResponse.json();
              
              // Handle response format (data might be in .data or root)
              const participantsData = participantsResult?.data || participantsResult;
              
              if (participantsData && Array.isArray(participantsData)) {
                // Get selected participant IDs for this event
                const eventKey = bookingEventData.schedule_id ? `schedule_${bookingEventData.schedule_id}` : `event_${bookingEventData.event_id}`;
                const loggedInEventParticipants = JSON.parse(localStorage.getItem('logged_in_event_participants') || '{}');
                const selectedParticipantIds = loggedInEventParticipants[eventKey] || [];
                
                // console.log('🔍 Participant Selection Debug:', {
                //   eventKey,
                //   allParticipantsCount: participantsData.length,
                //   selectedParticipantIds,
                //   selectedCount: selectedParticipantIds.length
                // });
                
                if (selectedParticipantIds.length === 0) {
                  throw new Error('No participants selected. Please go back and select participants.');
                }
                
                // Filter to only selected participants and format for API
                participants = participantsData
                  .filter(p => selectedParticipantIds.includes(p.participant_id || p.id))
                  .map(p => ({
                    participant_id: p.participant_id || p.id,
                    firstName: p.participate_first_name || p.first_name || '',
                    lastName: p.participate_last_name || p.last_name || '',
                    email: p.participate_email || p.email || '',
                    mobile: p.participate_mobile || p.mobile || '',
                    dateOfBirth: p.birth_date || p.date_of_birth || '',
                    gender: p.participate_gender || p.gender || '',
                    type: (p.participate_age && parseInt(p.participate_age) < 18) ? 'child' : 'adult'
                  }));
                
                // console.log('✅ Filtered selected participants for booking:', {
                //   participantCount: participants.length,
                //   participantIds: participants.map(p => p.participant_id),
                //   participants
                // });
                
                // Validate we got the expected number of participants
                if (participants.length !== selectedParticipantIds.length) {
                }
                
                // Critical validation: ensure we have participants after filtering
                if (participants.length === 0) {
                  throw new Error('Failed to load selected participants. Please go back and reselect participants.');
                }
              }
            } catch (error) {
              throw error;
            }
          }
          
          let bookingId = null;
          
          if (!user_id || user_id <= 0) {
            // GUEST USER FLOW: Create guest user + event booking
            const guestBillingArray = JSON.parse(localStorage.getItem('guest_billing_address') || '[]');
            const billingObj = {};
            guestBillingArray.forEach(item => {
              billingObj[item.name] = item.value;
            });
            
            const guestBookingPayload = {
              email: billingObj.billing_email || billingObj.email || '',
              firstName: billingObj.billing_first_name || billingObj.first_name || '',
              lastName: billingObj.billing_last_name || billingObj.last_name || '',
              mobile: billingObj.billing_mobile || billingObj.mobile || '',
              scheduleId: bookingEventData.schedule_id,
              participants: participants,
              comments: '' // Optional
            };
            
            // console.log('Creating guest event booking:', guestBookingPayload);
            // console.log('📤 Guest participants array length:', guestBookingPayload.participants?.length);
            // console.log('📤 Guest participants:', guestBookingPayload.participants);
            
            // Validate guest participants
            if (!participants || participants.length === 0) {
              throw new Error('No participants found. Please go back and add/select participants.');
            }
            
            const bookingResponse = await fetch(`${myConstClass.NODE_API_BASE}/guest/eventBooking`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(guestBookingPayload)
            });
            
            const bookingResult = await bookingResponse.json();
            // console.log('Guest event booking response:', bookingResult);
            
            if (bookingResult.status !== 'true' && bookingResult.status !== true) {
              throw new Error(bookingResult.message || 'Failed to create event booking');
            }
            
            bookingId = bookingResult.data?.booking?.bookingId || bookingResult.data?.bookingId;
            effective_user_id = bookingResult.data?.guestUser?.userId || effective_user_id;
            
            // Save booking ID for order details page to fetch canonical data
            if (bookingId) {
              localStorage.setItem('last_booking_id', bookingId);
            }
            
            // console.log('✅ Guest event booking created. Booking ID:', bookingId);
          } else {
            // LOGGED-IN USER FLOW: Create event booking for existing user
            // Participants were saved via eventDetails page, now create the booking
            
            // Get participant types from localStorage (saved in eventDetails)
            const participantTypesData = JSON.parse(localStorage.getItem('selected_participant_types') || '{}');
            
            // Get event's pricing types
            const firstPriceFor = (bookingEventData.first_price_for || 'person').toLowerCase();
            const secondPriceFor = bookingEventData.second_price_for ? bookingEventData.second_price_for.toLowerCase() : null;
            
            // Validate that all participants have types assigned
            const participantsWithoutType = participants.filter(p => {
              const participantId = p.participant_id || p.id;
              return !participantTypesData[participantId] || participantTypesData[participantId] === '';
            });
            
            if (participantsWithoutType.length > 0) {
              throw new Error('Some participants do not have a type selected. Please go back and select participant types.');
            }
            
            // Count participants by event's pricing types
            let firstTypeCount = 0;
            let secondTypeCount = 0;
            
            // Build participants array with types
            const participantsWithTypes = [];
            
            // console.log('🔍 Pre-validation check:', {
            //   participantsCount: participants?.length || 0,
            //   hasParticipants: participants && participants.length > 0,
            //   participants: participants
            // });
            
            if (!participants || participants.length === 0) {
              throw new Error('No participants found. Please go back and select participants.');
            }
            
            participants.forEach(p => {
              const participantId = p.participant_id || p.id;
              
              if (!participantId) {
                throw new Error('Invalid participant data. Please try again.');
              }
              
              const type = (participantTypesData[participantId] || firstPriceFor).toLowerCase();
              
              // Count based on event's pricing structure
              if (secondPriceFor && type === secondPriceFor) {
                secondTypeCount++;
              } else {
                firstTypeCount++;
              }
              
              participantsWithTypes.push({
                participant_id: participantId,
                type: type
              });
            });
            
            // console.log('📊 Participant counts by pricing type:', {
            //   total: participantsWithTypes.length,
            //   [firstPriceFor]: firstTypeCount,
            //   [secondPriceFor || 'N/A']: secondTypeCount
            // });
            
            // Final validation before creating payload
            if (participantsWithTypes.length === 0) {
              throw new Error('Failed to process participants. Please try again.');
            }
            
            const loggedInBookingPayload = {
              user_id: parseInt(effective_user_id),
              schedule_id: bookingEventData.schedule_id || undefined,
              event_id: bookingEventData.event_id || undefined,
              parent: firstTypeCount,  // Use first price type count
              child: secondTypeCount,  // Use second price type count
              participants: participantsWithTypes,
              comments: ''
            };
            
            // console.log('📤 Creating logged-in event booking:', loggedInBookingPayload);
            // console.log('📤 Participants array length:', loggedInBookingPayload.participants?.length);
            // console.log('📤 First participant sample:', loggedInBookingPayload.participants?.[0]);
            
            const bookingResponse = await fetch(`${myConstClass.NODE_API_BASE}/booking/createEventBooking`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(loggedInBookingPayload)
            });
            
            const bookingResult = await bookingResponse.json();
            // console.log('Logged-in event booking response:', bookingResult);
            
            if (bookingResult.status !== 'true' && bookingResult.status !== true) {
              throw new Error(bookingResult.message || 'Failed to create event booking');
            }
            
            bookingId = bookingResult.data?.booking?.bookingId || bookingResult.data?.bookingId;
            
            // Save booking ID for order details page to fetch canonical data
            if (bookingId) {
              localStorage.setItem('last_booking_id', bookingId);
            }
            
            // console.log('✅ Logged-in event booking created. Booking ID:', bookingId);
          }
          
          if (!bookingId) {
            throw new Error('Booking ID not returned from API');
          }
          
          // Step 2: Initiate payment for the event booking
          let paymentPayload = {};
          
          if (!user_id || user_id <= 0) {
            // Guest payment initiation
            const guestPaymentResponse = await fetch(`${myConstClass.NODE_API_BASE}/guest/initiateEventPayment/${bookingId}`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                userId: effective_user_id,
                comments: ''
              })
            });
            
            const guestPaymentResult = await guestPaymentResponse.json();
            // console.log('Guest event payment initiation response:', guestPaymentResult);
            
            if (guestPaymentResult.status !== 'true' && guestPaymentResult.status !== true) {
              throw new Error(guestPaymentResult.message || 'Failed to initiate event payment');
            }
            
            paymentPayload = guestPaymentResult.data || guestPaymentResult;
          } else {
            // Logged-in payment initiation
            const paymentResponse = await fetch(`${myConstClass.NODE_API_BASE}/payment/initiateEventPayment/${bookingId}`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                userId: parseInt(effective_user_id),
                comments: ''
              })
            });
            
            const paymentResult = await paymentResponse.json();
            // console.log('Logged-in event payment initiation response:', paymentResult);
            
            if (paymentResult.status !== 'true' && paymentResult.status !== true) {
              throw new Error(paymentResult.message || 'Failed to initiate event payment');
            }
            
            paymentPayload = paymentResult.data || paymentResult;
          }
          
          // Step 3: Check if this is a free event
          const isFreeEvent = paymentPayload.isFreeEvent || paymentPayload.redirectToOrderDetails;
          
          if (isFreeEvent) {
            // FREE EVENT: No payment needed, redirect to order details
            // console.log('🎁 Free event - skipping payment gateway, redirecting to order details');
            
            const order_id = paymentPayload.order_id || paymentPayload.orderId;
            const order_id_main = paymentPayload.order_id_main;
            
            // Store order_id for order details page
            if (order_id) {
              localStorage.setItem('last_displayed_order_id', order_id);
            }
            if (order_id_main) {
              localStorage.setItem('last_order_id_main', order_id_main);
            }
            if (bookingId) {
              localStorage.setItem('last_booking_id', bookingId);
            }
            
            // Clear event booking data
            localStorage.removeItem('booking_event');
            localStorage.removeItem('booking_event_guest');
            localStorage.removeItem('guest_event_participants');
            localStorage.removeItem('event_checkout_in_progress');
            
            // Show success message
            const successMsg = getLanguage() === 'ma' 
              ? 'विनामूल्य उपक्रम यशस्वीरित्या बुक झाला!'
              : paymentPayload.message || 'Free event booked successfully!';
            
            toast(successMsg, { containerId: 'B', type: toast.TYPE.SUCCESS });
            
            $('#btn_click').css('display', 'inline');
            $('#loader').css('display', 'none');
            
            // Redirect to order details page (use order_id, fallback to order_id_main)
            setTimeout(() => {
              const redirectId = order_id || order_id_main || localStorage.getItem('last_displayed_order_id');
              if (redirectId) {
                this.props.history.push('/order-details/' + redirectId);
              } else {
                // Fallback to generic orderdetails route
                this.props.history.push('/orderdetails');
              }
            }, 1500);
            
            return; // Exit early - free event complete
          }
          
          // PAID EVENT: Handle payment response and redirect to CCAvenue
          const encrypted_data = paymentPayload.encrypted_data || paymentPayload.encRequest;
          const access_code = paymentPayload.access_code || paymentPayload.accessCode;
          const order_id = paymentPayload.order_id || paymentPayload.orderId;
          const order_id_main = paymentPayload.order_id_main;
          
          if (!encrypted_data || !access_code) {
            throw new Error('Payment data incomplete (missing encrypted_data or access_code)');
          }
          
          // Store order_id for later use
          if (order_id) {
            localStorage.setItem('last_displayed_order_id', order_id);
          }
          
          // Set payment info in state
          this.setState({
            removeinfo: {
              encrypted_data: encrypted_data,
              access_code: access_code,
              order_id: order_id,
              order_id_main: order_id_main,
              status: 'true',
              message: 'Payment initiated successfully'
            }
          });
          
          // Clear event booking data from localStorage
          localStorage.removeItem('booking_event');
          localStorage.removeItem('booking_event_guest');
          localStorage.removeItem('guest_event_participants');
          localStorage.removeItem('event_checkout_in_progress');
          
          // Redirect to payment gateway
          $('#btn_click').css('display', 'inline');
          $('#loader').css('display', 'none');
          
          setTimeout(() => {
            // console.log('Submitting event payment form to CCAvenue...');
            $("#redirect").submit();
          }, 100);
          
          return; // Exit early - event payment flow complete
          
        } catch (error) {
          toast(error.message || 'Failed to process event booking. Please try again.', { 
            containerId: 'B', 
            type: toast.TYPE.ERROR 
          });
          $('#btn_click').css('display', 'inline');
          $('#loader').css('display', 'none');
          // Reset reCAPTCHA on error
          if (this.recaptchaRef.current && typeof this.recaptchaRef.current.reset === 'function') {
            this.recaptchaRef.current.reset();
          }
          this.setState({ recaptchaToken: null });
          return;
        }
    } else {
      // REGULAR CART CHECKOUT FLOW (non-events: products/magazines/machine tests)
      // Only proceed if there's a cart with items (total_price > 0)
      if (total_price != '' && total_price > 0) {
        var is_same_address = localStorage.getItem('is_same_address');
        
        // IMPORTANT: Transfer machine tests from localStorage to backend before payment
        // Check both guest_mt_cart (primary) and guest_cart_events (backup) for machine tests
        const guestMachineTests = JSON.parse(localStorage.getItem('guest_mt_cart') || '[]');
        const guestEvents = JSON.parse(localStorage.getItem('guest_cart_events') || '[]');
        const machineTestEvents = guestEvents.filter(e => e.event_type === 'Machine Test' || e.event_type_id === 3);
        
        // Combine machine tests from both sources
        const allMachineTests = [...guestMachineTests, ...machineTestEvents];
        
        if (allMachineTests.length > 0) {
          // Transfer each machine test to backend cart
          const transferPromises = allMachineTests.map(event => {
            const transferUrl = myConstClass.BASE_URL + `cart/addMachineTestEventToCart/${event.event_id}/${effective_user_id}/${event.parent || 0}/${event.child || 0}`;
            return fetch(transferUrl)
              .then(response => response.json())
              .then(result => {
                if (result.status !== 'true') {
                  throw new Error(`Failed to transfer machine test: ${result.message}`);
                }
                return result;
              })
              .catch(error => {
                throw error;
              });
          });
          
          // Wait for all transfers to complete
          try {
            await Promise.all(transferPromises);
          } catch (error) {
            $('#btn_click').css('display', 'inline');
            $('#loader').css('display', 'none');
            toast.error('Failed to process machine tests. Please try again.', { containerId: 'B' });
            if (this.recaptchaRef.current && typeof this.recaptchaRef.current.reset === 'function') {
              this.recaptchaRef.current.reset();
            }
            this.setState({ recaptchaToken: null });
            return;
          }
        }
        
      // Create the data structure the backend expects
      const formData = $('#captcha').serializeArray();
      formData.push({ name: 'g-recaptcha-response', value: recaptchaValue });
      fetch(myConstClass.BASE_URL + `payment/goToPayment/` + effective_user_id + '/' + is_same_address + '/' + delivery_type + '/' + total_shipping_charges, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData),  // Send as array format
      })
        .then(response => response.json())
        .then(response => {
          this.setState({ removeinfo: response })
          var message = this.state.removeinfo.message;
          var status = this.state.removeinfo.status;
          var order_id = this.state.removeinfo.order_id;
          
          // Debug: Log payment response data
          // console.log('Payment API Response:', response);
          // console.log('Order ID:', order_id);
          // console.log('Encrypted Data:', this.state.removeinfo.encrypted_data);
          // console.log('Access Code:', this.state.removeinfo.access_code);
          
          if (status == 'true') {
            // Validate required fields before redirect (order_id may be null for some gateways)
            if (!this.state.removeinfo.encrypted_data || !this.state.removeinfo.access_code) {
              $('#btn_click').css('display', 'inline');
              $('#loader').css('display', 'none');
              toast('Payment data incomplete. Please try again.', { 
                containerId: 'B', 
                type: toast.TYPE.ERROR 
              });
              // Reset reCAPTCHA on error
              if (this.recaptchaRef.current && typeof this.recaptchaRef.current.reset === 'function') {
                this.recaptchaRef.current.reset();
              }
              this.setState({ recaptchaToken: null });
              return;
            }
            if (!order_id) {
            }
            
            $('#btn_click').css('display', 'inline');
            $('#loader').css('display', 'none');
            
            this.state.removeinfo.encrypted_data = this.state.removeinfo.encrypted_data;
            this.state.removeinfo.access_code = this.state.removeinfo.access_code;

            // Check if this is an event booking (booking_event exists)
            const isEventBooking = localStorage.getItem('booking_event') || localStorage.getItem('booking_event_guest');
            
            if (isEventBooking) {
              // EVENT BOOKING: Only clear booking_event data, NOT the cart
              // Cart should remain intact for future product purchases
              // console.log('🎫 Event booking - clearing only booking_event data, keeping cart intact');
              localStorage.removeItem('event_checkout_in_progress');
              localStorage.removeItem('address_proceeding_to_checkout');
              localStorage.removeItem('booking_event');
              localStorage.removeItem('booking_event_guest');
              localStorage.removeItem('guest_event_participants');
            } else {
              // REGULAR CART CHECKOUT: Clear guest cart after successful order
              // console.log('🛒 Cart checkout - clearing guest cart data');
              localStorage.removeItem('guest_cart_products');
              localStorage.removeItem('guest_cart_magazines');
              localStorage.removeItem('guest_cart_events');
              localStorage.removeItem('guest_mt_cart'); // Clear machine test cart as well
              localStorage.removeItem('guest_billing_address');
              localStorage.removeItem('guest_shipping_address');
            }

            // Add small delay to ensure state is updated before form submission
            setTimeout(() => {
              $("#redirect").submit();
            }, 100);
          } else {
            $('#btn_click').css('display', 'inline');
            $('#loader').css('display', 'none');
            toast('' + message, { containerId: 'B', type: toast.TYPE.ERROR });
            // Reset reCAPTCHA on error
            this.recaptchaRef.current.reset();
          }
        })
        .catch(err => {
          // console.log(err);
          $('#btn_click').css('display', 'inline');
          $('#loader').css('display', 'none');
          // Reset reCAPTCHA on error
          this.recaptchaRef.current.reset();
        });
      } else {
        // Empty cart - show error
        $('#btn_click').css('display', 'inline');
        $('#loader').css('display', 'none');
        toast('You must have items in your cart.', { containerId: 'B', type: toast.TYPE.ERROR });
      }
    }
  }

  componentDidMount() {
    // Clear the proceeding flag when checkout page mounts (user successfully navigated from address page)
    localStorage.removeItem('address_proceeding_to_checkout');
    
    // Check for logged-in user OR auto-created guest user
    var user_id = localStorage.getItem("user_id"); // Logged-in user
    var guest_user_id = localStorage.getItem("guest_user_id_temp"); // Auto-created guest
    const isGuestAutoCreated = localStorage.getItem("isGuestAutoCreated");
    
    // NEW: Load booking event from localStorage (booking_event or booking_event_guest)
    let bookingEvent = null;
    if (user_id && user_id > 0) {
      const bookingEventStr = localStorage.getItem('booking_event');
      if (bookingEventStr) {
        bookingEvent = JSON.parse(bookingEventStr);
        // console.log('📅 Loaded booking_event for logged-in user:', bookingEvent);
      }
    } else {
      const bookingEventStr = localStorage.getItem('booking_event_guest');
      if (bookingEventStr) {
        bookingEvent = JSON.parse(bookingEventStr);
        // console.log('📅 Loaded booking_event_guest for guest user:', bookingEvent);
      }
    }
    
    if (bookingEvent) {
      // ========== EVENT BOOKING MODE ==========
      // When booking an event via booking_event/booking_event_guest, 
      // we SKIP all cart loading and only show this single event
      // console.log('🎫 EVENT BOOKING MODE - Skipping cart loading');
      
      // Load participant data for this event
      let participants = [];
      
      if (user_id && user_id > 0) {
        // LOGGED-IN USER: Fetch participants from Node API
        const nodeApiBase = myConstClass.NODE_API_BASE || myConstClass.BASE_URL.replace('/index.php/', '/api');
        const participantsUrl = `${nodeApiBase}/participants/getUserParticipants/${user_id}`;
        
        // console.log('🔄 Fetching participants for logged-in user from:', participantsUrl);
        
        fetch(participantsUrl)
          .then(response => response.json())
          .then(result => {
            const participantsData = result?.data || result;
            
            if (participantsData && Array.isArray(participantsData)) {
              // Get selected participant IDs from eventDetails (stored in localStorage)
              const eventKey = bookingEvent.schedule_id ? `schedule_${bookingEvent.schedule_id}` : `event_${bookingEvent.event_id}`;
              const loggedInEventParticipants = JSON.parse(localStorage.getItem('logged_in_event_participants') || '{}');
              const selectedParticipantIds = loggedInEventParticipants[eventKey] || [];
              
              // console.log('Selected participant IDs for logged-in user:', selectedParticipantIds);
              
              // Filter to only selected participants and format for display
              const selectedParticipants = participantsData
                .filter(p => selectedParticipantIds.includes(p.participant_id || p.id))
                .map(p => {
                  // Calculate age - try multiple approaches with fallbacks
                  let age = '';
                  
                  // Try birth_date first, then date_of_birth
                  const birthDateStr = p.birth_date || p.date_of_birth;
                  
                  if (birthDateStr) {
                    const birthDate = new Date(birthDateStr);
                    if (!isNaN(birthDate.getTime())) {
                      const today = new Date();
                      let calculatedAge = today.getFullYear() - birthDate.getFullYear();
                      const monthDiff = today.getMonth() - birthDate.getMonth();
                      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                        calculatedAge--;
                      }
                      if (calculatedAge >= 0) {
                        age = String(calculatedAge);
                        // console.log(`✅ Age calculated for ${p.participate_first_name || p.first_name}: ${age} from ${birthDateStr}`);
                      }
                    }
                  }
                  
                  // Fallback to existing age field if calculation didn't work
                  if (!age && (p.age || p.participate_age)) {
                    age = String(p.age || p.participate_age);
                    // console.log(`📌 Using existing age for ${p.participate_first_name || p.first_name}: ${age}`);
                  }
                  
                  if (!age) {
                  }
                  
                  return {
                    participant_id: p.participant_id || p.id,
                    first_name: p.participate_first_name || p.first_name || '',
                    middle_name: p.participate_middle_name || p.middle_name || '',
                    last_name: p.participate_last_name || p.last_name || '',
                    email: p.participate_email || p.email || '',
                    mobile: p.participate_mobile || p.mobile || '',
                    date_of_birth: birthDateStr || '',
                    age: age,
                    gender: p.participate_gender || p.gender || '',
                    address: p.participate_address || p.address || ''
                  };
                });
              
              // console.log('✅ Formatted participants for display:', selectedParticipants);
              
              // Calculate counts for donation display
              const participantTypesData = JSON.parse(localStorage.getItem('selected_participant_types') || '{}');
              const firstPriceFor = (bookingEvent.first_price_for || 'person').toLowerCase();
              const secondPriceFor = bookingEvent.second_price_for ? bookingEvent.second_price_for.toLowerCase() : null;
              
              let firstTypeCount = 0;
              let secondTypeCount = 0;
              
              selectedParticipantIds.forEach(participantId => {
                const type = (participantTypesData[participantId] || firstPriceFor).toLowerCase();
                if (secondPriceFor && type === secondPriceFor) {
                  secondTypeCount++;
                } else {
                  firstTypeCount++;
                }
              });
              
              const firstPrice = parseFloat(bookingEvent.price || 0);
              const secondPrice = parseFloat(bookingEvent.child_price || bookingEvent.price || 0);
              
              // Apply couple logic: 2 participants = 1 price unit (rounded up)
              let firstPriceUnits = firstTypeCount;
              let secondPriceUnits = secondTypeCount;
              
              if (firstPriceFor === 'couple') {
                firstPriceUnits = Math.ceil(firstTypeCount / 2);
                // console.log(`👫 Couple pricing applied for first type: ${firstTypeCount} participants = ${firstPriceUnits} units`);
              }
              
              if (secondPriceFor === 'couple') {
                secondPriceUnits = Math.ceil(secondTypeCount / 2);
                // console.log(`👫 Couple pricing applied for second type: ${secondTypeCount} participants = ${secondPriceUnits} units`);
              }
              
              const firstTotal = firstPrice * firstPriceUnits;
              const secondTotal = secondPrice * secondPriceUnits;
              const eventTotal = firstTotal + secondTotal;
              
              // console.log(`💰 Logged-in user event total: ${firstTypeCount} participants (${firstPriceUnits} units) × ₹${firstPrice} + ${secondTypeCount} participants (${secondPriceUnits} units) × ₹${secondPrice} = ₹${eventTotal}`);
              
              // Update the state with participants
              const formattedBookingEventWithParticipants = [{
                event_type: bookingEvent.event_type || 'Event',
                event_type_id: bookingEvent.event_type_id || 1,
                arr_cart: [{
                  ...bookingEvent,
                  first_price: bookingEvent.price,
                  second_price: bookingEvent.child_price || bookingEvent.price,
                  parent: firstTypeCount,
                  child: secondTypeCount,
                  parent_units: firstPriceUnits,
                  child_units: secondPriceUnits,
                  first_price_for: firstPriceFor,
                  second_price_for: secondPriceFor,
                  arr_participants: selectedParticipants
                }]
              }];
              
              // console.log('🎯 Setting complete state for logged-in user with participants');
              
              this.setState({ 
                bookingEvent: bookingEvent,
                cartEvent: formattedBookingEventWithParticipants,
                cart: [], // Empty cart - no products
                arrMagazine: [], // Empty magazines
                cartMachineTestEvent: [], // Empty machine test events (only booking event)
                eventinfo: {
                  ...this.state.eventinfo,
                  cart_total_price: eventTotal.toFixed(2)
                },
                cartTotal: {
                  cart_total_price: eventTotal
                }
              });
              
              // Load billing and shipping addresses for logged-in user with event booking
              localStorage.setItem('cart_total_price', eventTotal.toFixed(2));
              
              // Hide product/shipping related UI elements for event-only booking
              $('#noRecordsFoundTR').css('display', 'contents');
              $('#productTotalPrice').css('display', 'none');
              $('#allShippingCharges').css('display', 'none');
              $('#noShippingCharges').css('display', 'inline');
              $('#RegularTypeDiv').css('display', 'none');
              $('.productTable').css('display', 'none');
              $('.magazineTable').css('display', 'none');
              $('#noShippingChargesEventOnly').css('display', 'inline');
              
              // Load terms and conditions
              fetch(myConstClass.BASE_URL + 'terms/termsConditionsHTMLCheckout/' + user_id + '/' + getLanguage())
                .then(response => response.json())
                .then(response => {
                  this.setState({ termsinfo: response });
                });
              
              // Load billing address (address_type = 1)
              fetch(myConstClass.BASE_URL + 'users/getBillingAddress/1/' + user_id)
                .then(response => response.json())
                .then(response => {
                  if (response && response.length > 0) {
                    this.setState({ guestinfoarray: response, guestinfo: response[0] });
                  }
                });
              
              // Load shipping address (address_type = 2)
              fetch(myConstClass.BASE_URL + 'users/getBillingAddress/2/' + user_id)
                .then(response => response.json())
                .then(response => {
                  if (response && response.length > 0) {
                    this.setState({ eventinfoarray: response, eventinfo: { ...this.state.eventinfo, ...response[0] } });
                  }
                });
            }
          })
          .catch(error => {
          });
        
        // Don't create formattedBookingEvent here for logged-in users - it will be created after async fetch
        // Set initial state without participants (will be updated async)
        participants = [];
        
        // Return early for logged-in users - the rest will be handled in the async callback
        return;
      } else {
        // GUEST USER: Load from localStorage
        const guestEventParticipants = JSON.parse(localStorage.getItem('guest_event_participants') || '{}');
        const eventKey = bookingEvent.schedule_id ? `schedule_${bookingEvent.schedule_id}` : `event_${bookingEvent.event_id}`;
        const guestParticipantsRaw = guestEventParticipants[eventKey] || [];
        
        // Calculate age for each guest participant
        participants = guestParticipantsRaw.map(p => {
          let age = '';
          const dob = p.date_of_birth || p.birth_date;
          
          // console.log('🔍 Processing guest participant:', {
          //   name: p.first_name,
          //   date_of_birth: p.date_of_birth,
          //   birth_date: p.birth_date,
          //   existing_age: p.age,
          //   dob: dob
          // });
          
          if (dob) {
            const birthDate = new Date(dob);
            if (!isNaN(birthDate.getTime())) {
              const today = new Date();
              let calculatedAge = today.getFullYear() - birthDate.getFullYear();
              const monthDiff = today.getMonth() - birthDate.getMonth();
              if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                calculatedAge--;
              }
              if (calculatedAge >= 0) {
                age = String(calculatedAge);
                // console.log('✅ Calculated age:', age, 'from', dob);
              }
            } else {
            }
          }
          
          // Fallback to existing age field if calculation didn't work
          if (!age && p.age) {
            age = String(p.age);
            // console.log('📌 Using existing age for', p.first_name, ':', age);
          }
          
          if (!age) {
          }
          
          return {
            ...p,
            age: age // Use calculated age or existing age or empty string
          };
        });
        
        // console.log('📋 Loaded guest participants with ages:', participants.map(p => ({ name: p.first_name, age: p.age })));
      }
      
      // Format as cart event structure for display
      const formattedBookingEvent = [{
        event_type: bookingEvent.event_type || 'Event',
        event_type_id: bookingEvent.event_type_id || 1,
        arr_cart: [{
          ...bookingEvent,
          first_price: bookingEvent.price,
          second_price: bookingEvent.child_price || bookingEvent.price,
          arr_participants: participants
        }]
      }];
      
      // console.log('🎯 FormattedBookingEvent created with participants:', {
      //   participantCount: formattedBookingEvent[0].arr_cart[0].arr_participants.length,
      //   participants: formattedBookingEvent[0].arr_cart[0].arr_participants.map(p => ({
      //     name: p.first_name,
      //     age: p.age,
      //     dob: p.date_of_birth || p.birth_date
      //   }))
      // });
      
      // Calculate event total based on SELECTED participants and their types
      const eventKey = bookingEvent.schedule_id ? `schedule_${bookingEvent.schedule_id}` : `event_${bookingEvent.event_id}`;
      
      const firstPriceFor = (bookingEvent.first_price_for || 'person').toLowerCase();
      const secondPriceFor = bookingEvent.second_price_for ? bookingEvent.second_price_for.toLowerCase() : null;
      const firstPrice = parseFloat(bookingEvent.price || 0);
      const secondPrice = parseFloat(bookingEvent.child_price || bookingEvent.price || 0);
      
      let firstTypeCount = 0;
      let secondTypeCount = 0;
      
      if (user_id && user_id > 0) {
        // For logged-in users: count from selected_participant_types
        const participantTypesData = JSON.parse(localStorage.getItem('selected_participant_types') || '{}');
        const loggedInEventParticipants = JSON.parse(localStorage.getItem('logged_in_event_participants') || '{}');
        const selectedParticipantIds = loggedInEventParticipants[eventKey] || [];
        
        selectedParticipantIds.forEach(participantId => {
          const type = (participantTypesData[participantId] || firstPriceFor).toLowerCase();
          if (secondPriceFor && type === secondPriceFor) {
            secondTypeCount++;
          } else {
            firstTypeCount++;
          }
        });
      } else {
        // For guest users: count from guest_event_participants
        const guestEventParticipants = JSON.parse(localStorage.getItem('guest_event_participants') || '{}');
        const guestParticipants = guestEventParticipants[eventKey] || [];
        
        guestParticipants.forEach(p => {
          const type = (p.participant_type || firstPriceFor).toLowerCase();
          if (secondPriceFor && type === secondPriceFor) {
            secondTypeCount++;
          } else {
            firstTypeCount++;
          }
        });
      }
      
      // console.log(`🧮 Calculated participant counts by type:
      //   - ${firstPriceFor}: ${firstTypeCount}
      //   - ${secondPriceFor || 'N/A'}: ${secondTypeCount}`);
      
      // Apply couple logic: 2 participants = 1 price unit (rounded up)
      let firstPriceUnits = firstTypeCount;
      let secondPriceUnits = secondTypeCount;
      
      if (firstPriceFor === 'couple') {
        firstPriceUnits = Math.ceil(firstTypeCount / 2);
        // console.log(`👫 Couple pricing applied for first type: ${firstTypeCount} participants = ${firstPriceUnits} units`);
      }
      
      if (secondPriceFor === 'couple') {
        secondPriceUnits = Math.ceil(secondTypeCount / 2);
        // console.log(`👫 Couple pricing applied for second type: ${secondTypeCount} participants = ${secondPriceUnits} units`);
      }
      
      const firstTotal = firstPrice * firstPriceUnits;
      const secondTotal = secondPrice * secondPriceUnits;
      const eventTotal = firstTotal + secondTotal;
      
      // console.log(`💰 Booking event total breakdown:
      //   - ${firstPriceFor}: ${firstTypeCount} participants (${firstPriceUnits} units) × ₹${firstPrice} = ₹${firstTotal}
      //   - ${secondPriceFor || 'N/A'}: ${secondTypeCount} participants (${secondPriceUnits} units) × ₹${secondPrice} = ₹${secondTotal}
      //   - Total: ₹${eventTotal}`);
      
      // Update formattedBookingEvent with correct counts and units for donation display
      formattedBookingEvent[0].arr_cart[0].parent = firstTypeCount;
      formattedBookingEvent[0].arr_cart[0].child = secondTypeCount;
      formattedBookingEvent[0].arr_cart[0].parent_units = firstPriceUnits;
      formattedBookingEvent[0].arr_cart[0].child_units = secondPriceUnits;
      formattedBookingEvent[0].arr_cart[0].first_price_for = firstPriceFor;
      formattedBookingEvent[0].arr_cart[0].second_price_for = secondPriceFor;
      
      this.setState({ 
        bookingEvent: bookingEvent,
        cartEvent: formattedBookingEvent,
        cart: [], // Empty cart - no products
        arrMagazine: [], // Empty magazines
        cartMachineTestEvent: [], // Empty machine test events (only booking event)
        eventinfo: {
          ...this.state.eventinfo,
          cart_total_price: eventTotal.toFixed(2)
        },
        cartTotal: {
          cart_total_price: eventTotal
        }
      });
      
      localStorage.setItem('cart_total_price', eventTotal.toFixed(2));
      
      // Hide product/shipping related UI elements for event-only booking
      $('#noRecordsFoundTR').css('display', 'contents');
      $('#productTotalPrice').css('display', 'none');
      $('#allShippingCharges').css('display', 'none');
      $('#noShippingCharges').css('display', 'inline');
      $('#RegularTypeDiv').css('display', 'none');
      $('.productTable').css('display', 'none');
      $('.magazineTable').css('display', 'none');
      $('#noShippingChargesEventOnly').css('display', 'inline');
      
      // Use effective_user_id_event for billing/terms
      const effective_user_id_event = user_id || guest_user_id;
      
      // Only load terms and billing address (skip cart APIs)
      if (effective_user_id_event > 0) {
        fetch(myConstClass.BASE_URL + 'terms/termsConditionsHTMLCheckout/' + effective_user_id_event + '/' + getLanguage())
          .then(response => response.json())
          .then(response => {
            this.setState({ termsinfo: response });
          });
        
        // Load billing address
        var billing_address_id = 1;
        fetch(myConstClass.BASE_URL + 'users/getBillingAddress/' + billing_address_id + '/' + effective_user_id_event)
          .then(response => response.json())
          .then(response => {
            if (response && response.length > 0) {
              this.setState({ guestinfoarray: response, guestinfo: response[0] });
            } else {
              // Load from localStorage for guest
              const guestBilling = localStorage.getItem('guest_billing_address');
              if (guestBilling) {
                const billingArray = JSON.parse(guestBilling);
                const billingObj = {};
                billingArray.forEach(item => { billingObj[item.name] = item.value; });
                this.setState({ guestinfo: billingObj });
              }
            }
          });
        
        // Load shipping address
        var shipping_address_id = 2;
        fetch(myConstClass.BASE_URL + 'users/getBillingAddress/' + shipping_address_id + '/' + effective_user_id_event)
          .then(response => response.json())
          .then(response => {
            if (response && response.length > 0) {
              this.setState({ eventinfoarray: response, eventinfo: { ...this.state.eventinfo, ...response[0] } });
            } else {
              // Load from localStorage for guest
              const guestShipping = localStorage.getItem('guest_shipping_address');
              if (guestShipping) {
                const shippingArray = JSON.parse(guestShipping);
                const shippingObj = {};
                shippingArray.forEach(item => { shippingObj[item.name] = item.value; });
                this.setState({ eventinfo: { ...this.state.eventinfo, ...shippingObj } });
              }
            }
          });
      } else {
        // Guest without user_id - load from localStorage
        const guestBilling = localStorage.getItem('guest_billing_address');
        const guestShipping = localStorage.getItem('guest_shipping_address');
        if (guestBilling) {
          const billingArray = JSON.parse(guestBilling);
          const billingObj = {};
          billingArray.forEach(item => { billingObj[item.name] = item.value; });
          this.setState({ guestinfo: billingObj });
        }
        if (guestShipping) {
          const shippingArray = JSON.parse(guestShipping);
          const shippingObj = {};
          shippingArray.forEach(item => { shippingObj[item.name] = item.value; });
          this.setState({ eventinfo: { ...this.state.eventinfo, ...shippingObj } });
        }
      }
      
      // RETURN EARLY - Skip all cart loading below
      return;
    }
    
    // 🧪 DEV HELPER: Check URL for ?clearguest=1 to clear all guest session data for fresh testing
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('clearguest') === '1') {
  // console.warn('🧹 CLEARING ALL GUEST SESSION DATA (triggered by ?clearguest=1)');
  // localStorage.removeItem('guest_cart_products');
  // localStorage.removeItem('guest_cart_magazines');
  // localStorage.removeItem('guest_cart_events');
  // localStorage.removeItem('guest_billing_address');
  // localStorage.removeItem('guest_shipping_address');
  // localStorage.removeItem('guest_user_id_temp');
  // localStorage.removeItem('isGuestAutoCreated');
  // alert('✅ All guest session data cleared! Reload page or start fresh.');
  // window.history.replaceState({}, document.title, window.location.pathname); // Remove query param
    }
    
    // Use whichever is available
    var effective_user_id = user_id || guest_user_id;
    
    // console.log('🔍 Checkout componentDidMount - DEBUG:', {
    //   logged_in_user_id: user_id,
    //   guest_user_id_temp: guest_user_id,
    //   effective_user_id: effective_user_id,
    //   isGuestAutoCreated: isGuestAutoCreated,
    //   user_type: user_id ? 'LOGGED-IN USER' : (guest_user_id ? 'GUEST (NO SIGN-IN) ✅' : 'NO USER'),
    //   will_use_backend_api: effective_user_id > 0 ? 'YES ✅' : 'NO ❌ (FALLBACK)',
    //   localStorage_cart_data: {
    //     guest_cart_products: JSON.parse(localStorage.getItem('guest_cart_products') || '[]').length + ' items',
    //     guest_cart_magazines: JSON.parse(localStorage.getItem('guest_cart_magazines') || '[]').length + ' items',
    //     guest_cart_events: JSON.parse(localStorage.getItem('guest_cart_events') || '[]').length + ' items'
    //   }
    // });
    
    if (user_id) {
      localStorage.removeItem("error");
    }
    // Guest users can now access checkout page
    var current_language = getLanguage();
    localStorage.setItem('current_language', current_language);
    this.state.language = getLanguage();
    if (getLanguage() == 'ma') {
      this.state.languagePdf = "Terms_conditions_marathi.pdf";
    } else {
      this.state.languagePdf = "Terms_conditions.pdf";
    }
    //this.state.guestinfo.product_total_price = 0;
    const answer_array = this.props.location.pathname.split('/');

    if (effective_user_id > 0) {
      // Logged-in user OR auto-created guest user: fetch from backend
      // Note: Guest users get user_id after address page creates their account
      // This ensures BOTH user types get real shipping charges from backend!
      // Guest users use guest_user_id_temp (so they don't appear as "signed in" in UI)
      // console.log('✅ Using BACKEND API for cart data (getAllMyCartData)');
      fetch(myConstClass.BASE_URL + 'cart/getCartTotalPrice/' + effective_user_id)
        .then(response => response.json())
        .then(response => {
          const totalPrice = parseFloat(response.cart_total_price || 0).toFixed(2);
          this.setState({ 
            cartTotal: response,
            eventinfo: {
              ...this.state.eventinfo,
              cart_total_price: totalPrice
            }
          });
          localStorage.removeItem('cart_total_price');
          localStorage.setItem('cart_total_price', totalPrice);
          // console.log('✅ Cart total price set for guest/user:', totalPrice);
        })

      fetch(myConstClass.BASE_URL + 'cart/getAllMyCartData/' + effective_user_id + '/' + getLanguage())
        .then(response => response.json())
        .then(response => {
          // console.log('📦 getAllMyCartData API Response:', response);
          if (response && response[0]) {
            // console.log('💰 SHIPPING CHARGES FROM BACKEND:', {
            //   total_shipping_charges: response[0].total_shipping_charges,
            //   total_shipping_charges_express: response[0].total_shipping_charges_express,
            //   total_weight_in_kg: response[0].total_weight_in_kg,
            //   country_name: response[0].country_name,
            //   shipping_message: response[0].shipping_message,
            //   source: '✅ FROM DATABASE (delivery_charges table)'
            // });
          }
          
          this.setState({ cart: response })
          const numRows = this.state.cart.length;

          if (numRows < 1) {
            // var current_cart_total_price = localStorage.getItem('cart_total_price');
            // this.state.eventinfo.cart_total_price = parseFloat(current_cart_total_price).toFixed(2);
            $('#noRecordsFoundTR').css('display', 'contents');
            $('#productTotalPrice').css('display', 'none');
            $('#allShippingCharges').css('display', 'none');
            $('#noShippingCharges').css('display', 'inline');
            $('#RegularTypeDiv').css('display', 'none');
            $('.productTable').css('display', 'none');
            $('#noShippingChargesEventOnly').css('display', 'inline');
            $('.totalIncludingShippingChargesClass').click();
          } else {
            $('#noShippingChargesEventOnly').css('display', 'none');
            var total_shipping_charges = this.state.cart[0].total_shipping_charges;
            var current_shipping_charges = this.state.guestinfo.total_shipping_charges;

            var current_cart_total_price = localStorage.getItem('cart_total_price');

            var cart_total_price = (parseFloat(current_cart_total_price) + parseFloat(total_shipping_charges) + parseFloat(current_shipping_charges));

            var country_id = this.state.cart[0].country_id;

            if (country_id == 101) {
              $('#total_shipping_charges_express_row').css('display', 'flex');
            }
            this.setState({
              guestinfo: {
                ...this.state.guestinfo,
                product_total_price: this.state.cart[0].total_price,
                shipping_message: this.state.cart[0].shipping_message,
                country_name: this.state.cart[0].country_name,
                total_weight_in_kg: this.state.cart[0].total_weight_in_kg,
                total_shipping_charges: parseFloat(total_shipping_charges) + parseFloat(current_shipping_charges),
                total_shipping_charges_express: this.state.cart[0].total_shipping_charges_express,
              }
            });
          }
        })

      fetch(myConstClass.BASE_URL + 'cart/getAllMyCartDataForMachineTestEventsCheckout/' + effective_user_id + '/' + getLanguage())
        .then(response => response.json())
        .then(response => {
          // If backend returns data, use it; else fallback to guest_mt_cart for guests
          let machineTestData = response;
          if ((!response || response.length === 0) && guest_user_id) {
            const guestMachineTests = JSON.parse(localStorage.getItem('guest_mt_cart') || '[]');
            const guestEventParticipants = JSON.parse(localStorage.getItem('guest_event_participants') || '{}');
            if (guestMachineTests.length > 0) {
              // Format machine test events to match backend structure
              const formattedEvents = guestMachineTests.map(event => {
                const eventKey = event.schedule_id ? `schedule_${event.schedule_id}` : `event_${event.event_id}`;
                const participants = guestEventParticipants[eventKey] || [];
                return {
                  ...event,
                  first_price: event.first_price || event.price || '0',
                  second_price: event.second_price || event.child_price || event.first_price || event.price || '0',
                  child_price: event.child_price || event.second_price || event.first_price || event.price || '0',
                  arr_participants: participants
                };
              });
              machineTestData = [{
                event_type: 'Machine Test',
                event_type_id: 3,
                arr_cart: formattedEvents
              }];
              // Recalculate total to include machine test events
              const machineTestTotal = formattedEvents.reduce((sum, event) => {
                const parentPrice = parseFloat(event.first_price || 0) * parseInt(event.parent || 0);
                const childPrice = parseFloat(event.second_price || event.child_price || 0) * parseInt(event.child || 0);
                return sum + parentPrice + childPrice;
              }, 0);
              setTimeout(() => {
                const currentTotalFromStorage = parseFloat(localStorage.getItem('cart_total_price') || 0);
                const newTotal = (currentTotalFromStorage + machineTestTotal).toFixed(2);
                this.setState({
                  eventinfo: {
                    ...this.state.eventinfo,
                    cart_total_price: newTotal
                  },
                  cartTotal: {
                    ...this.state.cartTotal,
                    cart_total_price: parseFloat(newTotal)
                  }
                });
                localStorage.setItem('cart_total_price', newTotal);
              }, 200);
            } else {
              machineTestData = [];
            }
          }
          this.setState({ cartMachineTestEvent: machineTestData });
          // Optionally, display in UI: you can map over this.state.cartMachineTestEvent in render()
          const numRows = machineTestData.length;
          if (numRows < 1) {
            $('#noRecordsFoundEventTR').css('display', 'block');
          }
        })

      fetch(myConstClass.BASE_URL + 'terms/termsConditionsHTMLCheckout/' + effective_user_id + '/' + getLanguage())
        .then(response => response.json())
        .then(response => {
          this.setState({ termsinfo: response })

        })

      fetch(myConstClass.BASE_URL + 'cart/getAllMyCartDataForEventsCheckout/' + effective_user_id + '/' + getLanguage())
        .then(response => response.json())
        .then(response => {
          // console.log('🔍 REGULAR EVENTS FROM BACKEND:', response);
          
          // For guest users with auto-created accounts, fallback to localStorage if backend returns empty
          if (guest_user_id && (!response || response.length === 0)) {
            // console.log('⚠️ Guest user - backend returned empty, loading regular events from localStorage...');
            const guestEvents = JSON.parse(localStorage.getItem('guest_cart_events') || '[]');
            const guestEventParticipants = JSON.parse(localStorage.getItem('guest_event_participants') || '{}');
            
            // Filter regular events (non-machine test)
            const regularEvents = guestEvents.filter(e => e.event_type !== 'Machine Test' && e.event_type_id !== 3);
            
            if (regularEvents.length > 0) {
              // Format regular events to match backend structure
              const formattedEvents = regularEvents.map(event => {
                const eventKey = event.schedule_id ? `schedule_${event.schedule_id}` : `event_${event.event_id}`;
                const participants = guestEventParticipants[eventKey] || [];
                
                return {
                  ...event,
                  first_price: event.first_price || event.price || '0',
                  second_price: event.second_price || event.child_price || event.first_price || event.price || '0',
                  venue_address: event.venue_address || '',
                  arr_participants: participants
                };
              });
              
              response = [{
                event_type: 'Event',
                event_type_id: regularEvents[0]?.event_type_id || 1,
                arr_cart: formattedEvents
              }];
              // console.log('✅ Loaded regular events from localStorage:', response);
              
              // Recalculate total to include regular events
              const regularEventsTotal = formattedEvents.reduce((sum, event) => {
                const parentPrice = parseFloat(event.first_price || 0) * parseInt(event.parent || 0);
                const childPrice = parseFloat(event.second_price || event.child_price || 0) * parseInt(event.child || 0);
                return sum + parentPrice + childPrice;
              }, 0);
              
              // console.log('💰 Regular events total calculated:', regularEventsTotal);
              
              // Update cart total to include regular events
              // Use setTimeout to ensure other API calls have completed first
              setTimeout(() => {
                const currentTotalFromStorage = parseFloat(localStorage.getItem('cart_total_price') || 0);
                const newTotal = (currentTotalFromStorage + regularEventsTotal).toFixed(2);
                
                // console.log(`📊 Total calculation: ${currentTotalFromStorage} (current) + ${regularEventsTotal} (regular events) = ${newTotal}`);
                
                this.setState({
                  eventinfo: {
                    ...this.state.eventinfo,
                    cart_total_price: newTotal
                  },
                  cartTotal: {
                    ...this.state.cartTotal,
                    cart_total_price: parseFloat(newTotal)
                  }
                });
                localStorage.setItem('cart_total_price', newTotal);
                // console.log('✅ Total updated with regular events:', newTotal);
              }, 200); // Small delay to ensure initial total is set
            }
          } else if (guest_user_id && response && response.length > 0) {
            // Backend has data, but might need participants from localStorage
            const guestEventParticipants = JSON.parse(localStorage.getItem('guest_event_participants') || '{}');
            
            if (Object.keys(guestEventParticipants).length > 0) {
              // console.log('⚠️ Guest user - attaching participants from localStorage...');
              response = response.map(eventGroup => ({
                ...eventGroup,
                arr_cart: eventGroup.arr_cart.map(event => {
                  const eventKey = event.schedule_id ? `schedule_${event.schedule_id}` : `event_${event.event_id}`;
                  const participants = guestEventParticipants[eventKey] || event.arr_participants || [];
                  return {
                    ...event,
                    arr_participants: participants
                  };
                })
              }));
              // console.log('✅ Attached guest participants to regular events:', response);
            }
          }
          
          this.setState({ cartEvent: response })

          const numRows = this.state.cartEvent.length;
          if (numRows < 1) {
            $('#noRecordsFoundEventTR').css('display', 'block');
          }
        })

      // Helper function to fetch location names (reused from fallback section)
      const fetchLocationNames = async (addressObj) => {
        try {
          if (addressObj.country) {
            const countryResponse = await fetch(myConstClass.BASE_URL + 'getAllCountry');
            const countries = await countryResponse.json();
            const country = countries.find(c => c.country_id == addressObj.country);
            if (country) {
              addressObj.country_name = country.country_name;
            }
          }
          
          if (addressObj.country && addressObj.state) {
            const stateResponse = await fetch(myConstClass.BASE_URL + 'getStateCountryWise/' + addressObj.country);
            const states = await stateResponse.json();
            const state = states.find(s => s.state_id == addressObj.state);
            if (state) {
              addressObj.state_name = state.state_name;
            }
          }
          
          if (addressObj.state && addressObj.city) {
            const cityResponse = await fetch(myConstClass.BASE_URL + 'getCityStateWise/' + addressObj.state);
            const cities = await cityResponse.json();
            const city = cities.find(c => c.city_id == addressObj.city);
            if (city) {
              addressObj.city_name = city.city_name;
            }
          }
          
          return addressObj;
        } catch (error) {
          return addressObj;
        }
      };
      
      var billing_address_id = 1;
      fetch(myConstClass.BASE_URL + 'users/getBillingAddress/' + billing_address_id + '/' + effective_user_id)
        .then(response => response.json())
        .then(async response => {
          // console.log('🔍 Billing Address API Response:', response);
          // console.log('🔍 Response type:', typeof response, 'Is Array:', Array.isArray(response), 'Length:', response?.length);
          // console.log('🔍 Full response:', JSON.stringify(response, null, 2));
          
          // Check if API returned empty data for guest users
          if (!response || response.length === 0) {
            // console.log('⚠️ No billing address from API, checking localStorage for guest data...');
            
            // For guest users, try to read from localStorage as fallback
            const guestBilling = localStorage.getItem('guest_billing_address');
            if (guestBilling && guest_user_id) {
              const billingArray = JSON.parse(guestBilling);
              const billingObj = {};
              billingArray.forEach(item => {
                billingObj[item.name] = item.value;
              });
              // console.log('✅ Found guest billing address in localStorage, enriching with location names...');
              
              // Fetch location names for display
              const enrichedBilling = await fetchLocationNames(billingObj);
              // console.log('✅ Enriched billing address:', enrichedBilling);
              this.setState({ guestinfoarray: [enrichedBilling] });
            }
          } else {
            // console.log('✅ Setting billing address from API:', response);
            this.setState({ guestinfoarray: response }, () => {
              // console.log('✅ State updated. guestinfoarray length:', this.state.guestinfoarray.length);
              // console.log('✅ guestinfoarray content:', this.state.guestinfoarray);
            });
          }
          
          const numRows = response?.length || 0;
          // console.log('📋 Billing addresses loaded:', numRows);
        })
        .catch(async err => {
          
          // Fallback to localStorage for guest users
          const guestBilling = localStorage.getItem('guest_billing_address');
          if (guestBilling && guest_user_id) {
            const billingArray = JSON.parse(guestBilling);
            const billingObj = {};
            billingArray.forEach(item => {
              billingObj[item.name] = item.value;
            });
            //  console.log('✅ Using guest billing address from localStorage (after error), enriching...');
            
            // Fetch location names for display
            const enrichedBilling = await fetchLocationNames(billingObj);
            this.setState({ guestinfoarray: [enrichedBilling] });
          }
        })


      var billing_address_id = 2;
      fetch(myConstClass.BASE_URL + 'users/getBillingAddress/' + billing_address_id + '/' + effective_user_id)
        .then(response => response.json())
        .then(async response => {
          // console.log('🔍 Shipping Address API Response:', response);
          // console.log('🔍 Response type:', typeof response, 'Is Array:', Array.isArray(response), 'Length:', response?.length);
          // console.log('🔍 Full response:', JSON.stringify(response, null, 2));
          
          // Check if API returned empty data for guest users
          if (!response || response.length === 0) {
            // console.log('⚠️ No shipping address from API, checking localStorage for guest data...');
            
            // For guest users, try to read from localStorage as fallback
            const guestShipping = localStorage.getItem('guest_shipping_address');
            if (guestShipping && guest_user_id) {
              const shippingArray = JSON.parse(guestShipping);
              const shippingObj = {};
              shippingArray.forEach(item => {
                const displayKey = item.name.replace('shipping_', '');
                shippingObj[displayKey] = item.value;
              });
              // console.log('✅ Found guest shipping address in localStorage, enriching with location names...');
              
              // Fetch location names for display
              const enrichedShipping = await fetchLocationNames(shippingObj);
              // console.log('✅ Enriched shipping address:', enrichedShipping);
              this.setState({ eventinfoarray: [enrichedShipping] });
            }
          } else {
            // console.log('✅ Setting shipping address from API:', response);
            this.setState({ eventinfoarray: response }, () => {
              // console.log('✅ State updated. eventinfoarray length:', this.state.eventinfoarray.length);
              // console.log('✅ eventinfoarray content:', this.state.eventinfoarray);
            });
          }
          
          const numRows = response?.length || 0;
          // console.log('📋 Shipping addresses loaded:', numRows);
        })
        .catch(async err => {
          
          // Fallback to localStorage for guest users
          const guestShipping = localStorage.getItem('guest_shipping_address');
          if (guestShipping && guest_user_id) {
            const shippingArray = JSON.parse(guestShipping);
            const shippingObj = {};
            shippingArray.forEach(item => {
              const displayKey = item.name.replace('shipping_', '');
              shippingObj[displayKey] = item.value;
            });
            // console.log('✅ Using guest shipping address from localStorage (after error), enriching...');
            
            // Fetch location names for display
            const enrichedShipping = await fetchLocationNames(shippingObj);
            this.setState({ eventinfoarray: [enrichedShipping] });
          }
        })

      fetch(myConstClass.BASE_URL + 'cart/getAllMyCartDataForMagazine/' + effective_user_id + '/' + getLanguage())
        .then(response => response.json())
        .then(response => {
          this.setState({ arrMagazine: response })
          //var totalRecords =  this.state.cart[0].title;
          const numRows = this.state.arrMagazine.length;
          //alert(numRows);
          if (numRows > 0) {
            this.state.magazineinfo.totalMagazinePrice = this.state.arrMagazine[0].total_donation_contribution;
          } else {
            // console.log(this.state.arrMagazine[0].total_donation_contribution);
            //alert('here');
            $('.magazineTable').css('display', 'none');
          }
        })

        .catch(err => console.log(err))
    } else {
      // FALLBACK: Guest user without account (edge case - should go through address page first)
      // With the new flow, guest accounts are created on the address page
      // So this block should rarely execute - it's mainly for direct URL access
      
      const guestProducts = JSON.parse(localStorage.getItem('guest_cart_products') || '[]');
      const guestMagazines = JSON.parse(localStorage.getItem('guest_cart_magazines') || '[]');
      const guestEvents = JSON.parse(localStorage.getItem('guest_cart_events') || '[]');
      
      // DEBUG: Log what's in localStorage
      // console.log('🔍 CHECKOUT PAGE - GUEST CART DATA:', {
      //   guestProducts: guestProducts,
      //   guestMagazines: guestMagazines,
      //   guestEvents: guestEvents,
      //   note: 'Check if there are unwanted items from previous sessions'
      // });
      
      // Calculate product total price
      let productTotalPrice = 0;
      guestProducts.forEach(item => {
        productTotalPrice += parseFloat(item.price || 0) * parseInt(item.quantity || 1);
      });
      
      // Calculate magazine total price
      let magazineTotalPrice = 0;
      guestMagazines.forEach(item => {
        magazineTotalPrice += parseFloat(item.donation_contribution || item.price || 0);
      });
      
      // Calculate event total price
      let eventTotalPrice = 0;
      guestEvents.forEach(item => {
        const parentPrice = parseFloat(item.price || 0) * parseInt(item.parent || 0);
        const childPrice = parseFloat(item.child_price || item.price || 0) * parseInt(item.child || 0);
        eventTotalPrice += parentPrice + childPrice;
      });
      
      // For guest users, we need to call backend API to get proper shipping charges
      // We'll fetch this after setting up the initial cart data
      let totalShippingCharges = 0;
      let totalShippingChargesExpress = 0;
      let totalWeight = 0;
      let countryId = 101; // Default to India
      
      // Get country and state from shipping address if available
      const guestShippingArray = JSON.parse(localStorage.getItem('guest_shipping_address') || '[]');
      const shippingCountry = guestShippingArray.find(item => item.name === 'shipping_country');
      const shippingState = guestShippingArray.find(item => item.name === 'shipping_state');
      let stateId = 0;
      
      if (shippingCountry) {
        countryId = parseInt(shippingCountry.value);
      }
      if (shippingState) {
        stateId = parseInt(shippingState.value);
      }
      
      // Calculate total price (products + magazines + events) - shipping will be added after API call
      const subtotal = productTotalPrice + magazineTotalPrice + eventTotalPrice;
      
      // Load guest event participants and attach them to events
      const guestEventParticipants = JSON.parse(localStorage.getItem('guest_event_participants') || '{}');
      // console.log('🔍 Guest event participants loaded:', guestEventParticipants);
      
      // Helper function to attach participants to events
      const attachParticipantsToEvent = (event) => {
        const eventKey = event.schedule_id ? `schedule_${event.schedule_id}` : `event_${event.event_id}`;
        const participants = guestEventParticipants[eventKey] || [];
        
        return {
          ...event,
          arr_participants: participants
        };
      };
      
      // Filter and format events with participants
      const regularEvents = guestEvents
        .filter(e => e.event_type !== 'Machine Test' && e.event_type_id !== 3)
        .map(attachParticipantsToEvent);
      
      const machineTestEvents = guestEvents
        .filter(e => e.event_type === 'Machine Test' || e.event_type_id === 3)
        .map(event => {
          // Ensure all required fields are present for machine test events
          const eventWithParticipants = attachParticipantsToEvent(event);
          return {
            ...eventWithParticipants,
            first_price: eventWithParticipants.first_price || eventWithParticipants.price || '0',
            second_price: eventWithParticipants.second_price || eventWithParticipants.child_price || eventWithParticipants.first_price || eventWithParticipants.price || '0',
            child_price: eventWithParticipants.child_price || eventWithParticipants.second_price || eventWithParticipants.first_price || eventWithParticipants.price || '0'
          };
        });
      
      // Format events to match backend structure with arr_cart
      const formattedRegularEvents = regularEvents.length > 0 ? [{
        event_type: 'Event',
        arr_cart: regularEvents
      }] : [];
      
      const formattedMachineTestEvents = machineTestEvents.length > 0 ? [{
        event_type: 'Machine Test',
        arr_cart: machineTestEvents
      }] : [];
      
      // console.log('🔍 Formatted regular events:', formattedRegularEvents);
      // console.log('🔍 Formatted machine test events:', formattedMachineTestEvents);
      
      // Set initial state with subtotal (without shipping)
      this.setState({ 
        cartTotal: { cart_total_price: subtotal },
        cart: guestProducts.map(product => ({
          ...product,
          total_price: productTotalPrice
        })),
        arrMagazine: guestMagazines.map(mag => ({
          ...mag,
          magazine_title: mag.title || mag.magazine_title,
          total_donation_contribution: mag.donation_contribution || mag.price || 0
        })),
        cartEvent: formattedRegularEvents,
        cartMachineTestEvent: formattedMachineTestEvents,
        guestinfo: {
          ...this.state.guestinfo,
          product_total_price: productTotalPrice,
          total_shipping_charges: 0,
          total_shipping_charges_express: 0,
          total_weight_in_kg: 0,
          country_id: countryId,
          country_name: countryId == 101 ? 'India' : 'Other',
          shipping_message: ''
        },
        magazineinfo: {
          ...this.state.magazineinfo,
          totalMagazinePrice: magazineTotalPrice
        },
        eventinfo: {
          ...this.state.eventinfo,
          cart_total_price: subtotal.toFixed(2)
        }
      });
      
      localStorage.setItem('cart_total_price', subtotal.toFixed(2));
      
      // For guest users with products, we'll show estimated shipping using fallback
      // Real shipping will be calculated when they create account and transfer cart
      // (The existing getAllMyCartData API will be used after account creation)
      if (guestProducts.length > 0) {
        // console.log('Calculating estimated shipping for guest cart...');
        this.updateGuestShippingFallback(subtotal, countryId, stateId, guestProducts);
      }
      
      // Debug logging
      // console.log('Guest checkout initial data:', {
      //   productTotalPrice,
      //   magazineTotalPrice,
      //   eventTotalPrice,
      //   subtotal,
      //   countryId,
      //   note: 'Shipping charges will be fetched from backend'
      // });
      
      // Load guest addresses if available
      const guestBilling = localStorage.getItem('guest_billing_address');
      const guestShipping = localStorage.getItem('guest_shipping_address');
      
      // Helper function to convert serialized form array to object
      const convertFormArrayToObject = (formArray) => {
        const obj = {};
        formArray.forEach(item => {
          obj[item.name] = item.value;
        });
        return obj;
      };
      
      // Helper function to fetch location names by IDs
      const fetchLocationNames = async (addressObj) => {
        try {
          // console.log('Fetching location names for:', addressObj);
          
          // Fetch country name
          if (addressObj.country) {
            // console.log('Fetching country for ID:', addressObj.country);
            const countryResponse = await fetch(myConstClass.BASE_URL + 'getAllCountry');
            const countries = await countryResponse.json();
            const country = countries.find(c => c.country_id == addressObj.country);
            if (country) {
              addressObj.country_name = country.country_name;
            //   console.log('Found country name:', country.country_name);
            } else {
            }
          }
          
          // Fetch state name
          if (addressObj.country && addressObj.state) {
            // console.log('Fetching state for ID:', addressObj.state);
            const stateResponse = await fetch(myConstClass.BASE_URL + 'getStateCountryWise/' + addressObj.country);
            const states = await stateResponse.json();
            const state = states.find(s => s.state_id == addressObj.state);
            if (state) {
              addressObj.state_name = state.state_name;
              // console.log('Found state name:', state.state_name);
            } else {
            }
          }
          
          // Fetch city name
          if (addressObj.state && addressObj.city) {
            // console.log('Fetching city for ID:', addressObj.city);
            const cityResponse = await fetch(myConstClass.BASE_URL + 'getCityStateWise/' + addressObj.state);
            const cities = await cityResponse.json();
            const city = cities.find(c => c.city_id == addressObj.city);
            if (city) {
              addressObj.city_name = city.city_name;
              // console.log('Found city name:', city.city_name);
            } else {
            }
          }
          
          // comment.log('Final enriched address:', addressObj);
          return addressObj;
        } catch (error) {
          return addressObj;
        }
      };
      
      if (guestBilling) {
        const billingArray = JSON.parse(guestBilling);
        const billingObj = convertFormArrayToObject(billingArray);
        // console.log('Guest billing address:', billingObj);
        
        // Fetch location names and update state
        fetchLocationNames(billingObj).then(enrichedBilling => {
          // console.log('Guest billing address with names:', enrichedBilling);
          this.setState({ guestinfoarray: [enrichedBilling] });
        });
      }
      
      if (guestShipping) {
        const shippingArray = JSON.parse(guestShipping);
        const shippingObj = convertFormArrayToObject(shippingArray);
        // Convert shipping_ prefixed fields to regular fields for display
        const displayObj = {};
        Object.keys(shippingObj).forEach(key => {
          const displayKey = key.replace('shipping_', '');
          displayObj[displayKey] = shippingObj[key];
        });
          // console.log('Guest shipping address:', displayObj);
        
        // Fetch location names and update state
        fetchLocationNames(displayObj).then(enrichedShipping => {
          // console.log('Guest shipping address with names:', enrichedShipping);
          this.setState({ eventinfoarray: [enrichedShipping] });
        });
      }
      
      // Auto-fill billing address from shipping address if billing is empty
      if (guestShipping && !guestBilling) {
        const shippingData = JSON.parse(guestShipping);
        const billingData = shippingData.map(item => ({
          name: item.name.replace('shipping_', ''),
          value: item.value
        }));
        localStorage.setItem('guest_billing_address', JSON.stringify(billingData));
        
        // Convert to object for display
        const billingObj = convertFormArrayToObject(billingData);
        // console.log('Auto-filled billing address:', billingObj);
        
        // Fetch location names and update state
        fetchLocationNames(billingObj).then(enrichedBilling => {
          // console.log('Auto-filled billing address with names:', enrichedBilling);
          this.setState({ guestinfoarray: [enrichedBilling] });
        });
      }
      
      // Handle UI display for guest cart (similar to logged-in user)
      if (guestProducts.length < 1) {
        $('#noRecordsFoundTR').css('display', 'contents');
        $('#productTotalPrice').css('display', 'none');
        $('#allShippingCharges').css('display', 'none');
        $('#noShippingCharges').css('display', 'inline');
        $('#RegularTypeDiv').css('display', 'none');
        $('.productTable').css('display', 'none');
        $('#noShippingChargesEventOnly').css('display', 'inline');
      } else {
        // Show product-related UI elements
        $('#noRecordsFoundTR').css('display', 'none');
        $('#noShippingChargesEventOnly').css('display', 'none');
        $('#productTotalPrice').css('display', 'block');
        $('#allShippingCharges').css('display', 'block');
        $('#noShippingCharges').css('display', 'none');
        $('#RegularTypeDiv').css('display', 'block');
        $('.productTable').css('display', 'block');
        
        // Show express shipping option for India
        if (countryId == 101) {
          $('#total_shipping_charges_express_row').css('display', 'flex');
        }
      }
      
      if (guestMagazines.length < 1) {
        $('.magazineTable').css('display', 'none');
      } else {
        $('.magazineTable').css('display', 'block');
      }
      
      if (guestEvents.length < 1) {
        $('#noRecordsFoundEventTR').css('display', 'block');
      } else {
        $('#noRecordsFoundEventTR').css('display', 'none');
      }
      
      // Load terms and conditions (not user-specific)
      fetch(myConstClass.BASE_URL + 'terms/termsConditionsHTMLCheckout/0/' + getLanguage())
        .then(response => response.json())
        .then(response => {
          this.setState({ termsinfo: response })
        })
        .catch(err => console.log(err))
    }



  }

  componentDidUpdate(prevProps) {
    var current_language = localStorage.getItem('current_language');
    const { flag } = this.state
    if (current_language != getLanguage() && flag != 1 && current_language != null) {
      this.setState({ flag: 1 });

      // alert(this.state.languagePdf);
      localStorage.removeItem('current_language');
      localStorage.setItem('current_language', getLanguage());
    }
    this.state.language = getLanguage();
    if (getLanguage() == 'ma') {
      this.state.languagePdf = "Terms_conditions_marathi.pdf";

    } else {
      this.state.languagePdf = "Terms_conditions.pdf";
    }

    if (getLanguage() == 'ma' && flag == 1) {
      // this.state.guestinfo.total_shipping_charges = 0;
      // this.state.guestinfo.total_shipping_charges_express = 0;
      // this.state.eventinfo.cart_total_price = 0;
      //localStorage.removeItem('cart_total_price');
      //this.state.eventinfo.cart_total_price = 0;
      this.setState({ flag: 0 })
      var user_id = localStorage.getItem('user_id');
      if (user_id > 0) {

        fetch(myConstClass.BASE_URL + 'cart/getCartTotalPrice/' + user_id)
          .then(response => response.json())
          .then(response => {
            this.setState({ cartTotal: response })
            //var totalRecords =  this.state.cart[0].title;
            //const numRows = this.state.cartTotal.length;
            // this.state.eventinfo.cart_total_price = parseFloat(this.state.cartTotal.cart_total_price).toFixed(2);
            // this.state.eventinfo.cart_total_price = parseFloat(this.state.cartTotal.cart_total_price).toFixed(2);
            var product_shipping_charges = parseFloat(this.state.cartTotal.cart_total_price).toFixed(2);
            localStorage.removeItem('cart_total_price');
            localStorage.setItem('cart_total_price', product_shipping_charges);

          })

        fetch(myConstClass.BASE_URL + 'cart/getAllMyCartData/' + user_id + '/' + getLanguage())
          .then(response => response.json())
          .then(response => {
            this.setState({ cart: response })
            const numRows = this.state.cart.length;

            if (numRows < 1) {
              var current_cart_total_price = localStorage.getItem('cart_total_price');
              const totalPrice = parseFloat(current_cart_total_price || 0).toFixed(2);
              this.setState({
                eventinfo: {
                  ...this.state.eventinfo,
                  cart_total_price: totalPrice
                }
              });
              $('#noRecordsFoundTR').css('display', 'contents');
              $('#productTotalPrice').css('display', 'none');
              $('#allShippingCharges').css('display', 'none');
              $('#noShippingCharges').css('display', 'inline');
              $('#RegularTypeDiv').css('display', 'none');
              $('.productTable').css('display', 'none');
            } else {
              var country_id = this.state.cart[0].country_id;
              if (country_id == 101) {
                $('#total_shipping_charges_express_row').css('display', 'flex');
              }
              this.setState({
                guestinfo: {
                  ...this.state.guestinfo,
                  product_total_price: this.state.cart[0].total_price,
                  shipping_message: this.state.cart[0].shipping_message,
                  country_name: this.state.cart[0].country_name,
                  total_shipping_charges_express: this.state.cart[0].total_shipping_charges_express,
                }
              });
            }
          })

        fetch(myConstClass.BASE_URL + 'cart/getAllMyCartDataForMachineTestEventsCheckout/' + user_id + '/' + getLanguage())
          .then(response => response.json())
          .then(response => {
            this.setState({ cartMachineTestEvent: response })
            //var totalRecords =  this.state.cart[0].title;
            const numRows = this.state.cartMachineTestEvent.length;
            if (numRows < 1) {
              $('#noRecordsFoundEventTR').css('display', 'block');
            }
          })

        fetch(myConstClass.BASE_URL + 'cart/getAllMyCartDataForEventsCheckout/' + user_id + '/' + getLanguage())
          .then(response => response.json())
          .then(response => {
            this.setState({ cartEvent: response })
            //var totalRecords =  this.state.cart[0].title;
            const numRows = this.state.cartEvent.length;
            if (numRows < 1) {
              $('#noRecordsFoundEventTR').css('display', 'block');
            }
          })






        var billing_address_id = 1;
        fetch(myConstClass.BASE_URL + 'users/getBillingAddress/' + billing_address_id + '/' + user_id)
          .then(response => response.json())
          .then(response => {
            this.setState({ guestinfoarray: response })
            const numRows = this.state.guestinfoarray.length;
            //if(numRows > 0){

            //}

            // //var totalRecords =  this.state.cart[0].title;
            // const numRows = this.state.cart.length;
            // if(numRows < 1){
            //     $('#noRecordsFoundTR').css('display','block');
            // }
          })


        var billing_address_id = 2;
        fetch(myConstClass.BASE_URL + 'users/getBillingAddress/' + billing_address_id + '/' + user_id)
          .then(response => response.json())
          .then(response => {
            this.setState({ eventinfoarray: response })
            const numRows = this.state.eventinfoarray.length;
            //if(numRows > 0){


            // }
            // //var totalRecords =  this.state.cart[0].title;
            // const numRows = this.state.cart.length;
            // if(numRows < 1){
            //     $('#noRecordsFoundTR').css('display','block');
            // }
          })

        fetch(myConstClass.BASE_URL + 'cart/getAllMyCartDataForMagazine/' + user_id + '/' + getLanguage())
          .then(response => response.json())
          .then(response => {
            this.setState({ arrMagazine: response })
            //var totalRecords =  this.state.cart[0].title;
            const numRows = this.state.arrMagazine.length;
            //alert(numRows);
            if (numRows > 0) {
              this.state.magazineinfo.totalMagazinePrice = this.state.arrMagazine[0].total_donation_contribution;
            } else {
              // console.log(this.state.arrMagazine[0].total_donation_contribution);
              //alert('here');
              $('.magazineTable').css('display', 'none');
            }
          })

          .catch(err => console.log(err))
      }


    }

    if (getLanguage() == 'en' && (flag == 1)) {
      // this.state.guestinfo.total_shipping_charges = 0;
      // this.state.guestinfo.total_shipping_charges_express = 0;
      // this.state.eventinfo.cart_total_price = 0;
      // localStorage.removeItem('cart_total_price');
      this.setState({ flag: 0 })



      var user_id = localStorage.getItem('user_id');
      if (user_id > 0) {

        fetch(myConstClass.BASE_URL + 'cart/getCartTotalPrice/' + user_id)
          .then(response => response.json())
          .then(response => {
            const totalPrice = parseFloat(response.cart_total_price || 0).toFixed(2);
            this.setState({ 
              cartTotal: response,
              eventinfo: {
                ...this.state.eventinfo,
                cart_total_price: totalPrice
              }
            });
            localStorage.removeItem('cart_total_price');
            localStorage.setItem('cart_total_price', totalPrice);
          })

        fetch(myConstClass.BASE_URL + 'cart/getAllMyCartData/' + user_id + '/' + getLanguage())
          .then(response => response.json())
          .then(response => {
            this.setState({ cart: response })
            const numRows = this.state.cart.length;

            if (numRows < 1) {
              var current_cart_total_price = localStorage.getItem('cart_total_price');
              const totalPrice = parseFloat(current_cart_total_price || 0).toFixed(2);
              this.setState({
                eventinfo: {
                  ...this.state.eventinfo,
                  cart_total_price: totalPrice
                }
              });
              $('#noRecordsFoundTR').css('display', 'contents');
              $('#productTotalPrice').css('display', 'none');
              $('#allShippingCharges').css('display', 'none');
              $('#noShippingCharges').css('display', 'inline');
              $('#RegularTypeDiv').css('display', 'none');
              $('.productTable').css('display', 'none');
            } else {
              var country_id = this.state.cart[0].country_id;
              if (country_id == 101) {
                $('#total_shipping_charges_express_row').css('display', 'flex');
              }
              this.setState({
                guestinfo: {
                  ...this.state.guestinfo,
                  product_total_price: this.state.cart[0].total_price,
                  shipping_message: this.state.cart[0].shipping_message,
                  country_name: this.state.cart[0].country_name,
                  total_shipping_charges_express: this.state.cart[0].total_shipping_charges_express,
                }
              });
            }
          })

        fetch(myConstClass.BASE_URL + 'cart/getAllMyCartDataForMachineTestEventsCheckout/' + user_id + '/' + getLanguage())
          .then(response => response.json())
          .then(response => {
            this.setState({ cartMachineTestEvent: response })
            //var totalRecords =  this.state.cart[0].title;
            const numRows = this.state.cartMachineTestEvent.length;
            if (numRows < 1) {
              $('#noRecordsFoundEventTR').css('display', 'block');
            }
          })

        fetch(myConstClass.BASE_URL + 'cart/getAllMyCartDataForEventsCheckout/' + user_id + '/' + getLanguage())
          .then(response => response.json())
          .then(response => {
            this.setState({ cartEvent: response })
            //var totalRecords =  this.state.cart[0].title;
            const numRows = this.state.cartEvent.length;
            if (numRows < 1) {
              $('#noRecordsFoundEventTR').css('display', 'block');
            }
          })






        var billing_address_id = 1;
        fetch(myConstClass.BASE_URL + 'users/getBillingAddress/' + billing_address_id + '/' + user_id)
          .then(response => response.json())
          .then(response => {
            this.setState({ guestinfoarray: response })
            const numRows = this.state.guestinfoarray.length;
            //if(numRows > 0){

            //}

            // //var totalRecords =  this.state.cart[0].title;
            // const numRows = this.state.cart.length;
            // if(numRows < 1){
            //     $('#noRecordsFoundTR').css('display','block');
            // }
          })


        var billing_address_id = 2;
        fetch(myConstClass.BASE_URL + 'users/getBillingAddress/' + billing_address_id + '/' + user_id)
          .then(response => response.json())
          .then(response => {
            this.setState({ eventinfoarray: response })
            const numRows = this.state.eventinfoarray.length;
            //if(numRows > 0){


            // }
            // //var totalRecords =  this.state.cart[0].title;
            // const numRows = this.state.cart.length;
            // if(numRows < 1){
            //     $('#noRecordsFoundTR').css('display','block');
            // }
          })

        fetch(myConstClass.BASE_URL + 'cart/getAllMyCartDataForMagazine/' + user_id + '/' + getLanguage())
          .then(response => response.json())
          .then(response => {
            this.setState({ arrMagazine: response })
            //var totalRecords =  this.state.cart[0].title;
            const numRows = this.state.arrMagazine.length;
            //alert(numRows);
            if (numRows > 0) {
              this.state.magazineinfo.totalMagazinePrice = this.state.arrMagazine[0].total_donation_contribution;
            } else {
              // console.log(this.state.arrMagazine[0].total_donation_contribution);
              //alert('here');
              $('.magazineTable').css('display', 'none');
            }
          })

          .catch(err => console.log(err))
      }

    }

    const answer_array = this.props.location.pathname.split('/');
  }

  async componentWillUnmount() {
    // Don't remove events when unmounting from checkout page
    // User should be able to navigate back and forth within the checkout flow
    // Events will only be removed if user navigates away from earlier pages (eventDetails, address)
    
    // Note: We don't clear the event_checkout_in_progress flag here
    // It will be cleared when payment is successful or when user navigates away from the flow
  }

  handleChange(event) {
    this.setState({ value: event.target.value });
  }


  changeArrowDirection(event) {
    if ($("#" + event.target.id).hasClass('rotate180')) {
      $("#" + event.target.id).addClass('rotate0');
      $("#" + event.target.id).removeClass('rotate180');
    } else {
      $(".image_main_carosal").addClass('rotate0');
      $(".image_main_carosal").removeClass('rotate180');

      $("#" + event.target.id).addClass('rotate180');
      $("#" + event.target.id).removeClass('rotate0');
    }


    const checkoutHeaderTop = document.getElementById('checkoutHeader').getBoundingClientRect().top;
    setTimeout(() => {
      window.scrollTo({
        top: checkoutHeaderTop,
        behavior: "smooth",
      })
    }, 250)

  }

  render() {
    const { termsinfo, magazineinfo, arrMagazine, removeinfo, cartMachineTestEvent, cartEvent, posts, guestinfo, cart, eventinfo, cartTotal, eventinfoarray, guestinfoarray } = this.state
    const { t } = this.props;
    let ship_charg_value;
    ship_charg_value = parseFloat(this.state.cartTotal.cart_total_price).toFixed(2);
    if (ship_charg_value) {
      ship_charg_value = ship_charg_value;
    } else {
      ship_charg_value = "0.00";
    }


    return (

      <div className="App">
        <div>
          {/* <button onClick={this.notify}>Notify !</button> */}
          <ToastContainer />

        </div>
        <NewHeader />
        <div className="container-fluid">
          <Helmet>
            {/* reCAPTCHA v2 for checkout page - PHP backend uses v2 verification */}
          </Helmet>
          <div className="row">
            <div className="col-lg-12">
              <div className="row mt-5 m-xl-0 mt-lg-0 mt-md-4 mt-sm-5">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb bg-white mb-0">
                    <li className="breadcrumb-item">
                      <Link to="/">{t('home.home')}</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/mycart">{t('home.Shopping Cart')}</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">{t('home.Checkout')}</li>

                  </ol>
                </nav>
              </div>
              <div className="row" id='checkoutHeader'>
                <div className="col-12">
                  <h5 style={{ fontSize: '20px', }}>{t('home.CHECKOUT')}</h5>
                </div>
              </div>
              <div className="row" >
                <div className="col-lg-10">
                  <div id="accordion">
                    <div className="card my-3">
                      <div className="card-header bg-dark-grey-old" id="headingOne" aria-expanded="false" aria-controls="collapseOne">
                        <h5 className="mb-0">
                          {t('SELECTED ITEMS')}

                        </h5>

                        <img
                          id="arrowOne"
                          onClick={this.changeArrowDirection}
                          style={{ height: '20px', width: '20px', float: 'right', marginTop: '-20px', cursor: 'pointer', cursor: 'pointer', cursor: 'pointer', cursor: 'pointer', cursor: 'pointer', cursor: 'pointer', cursor: 'pointer' }} className="image_main_carosal" src={checkoutImage}
                          data-toggle="collapse"
                          data-target="#collapseOne" />

                      </div>

                      <div id="collapseOne" className="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                        <div className="p-0 d-xl-block d-lg-block d-none">

                          <table className="table table-bordered">

                            {/* Machine Test Table Header - Bold */}
                            {this.state.cartMachineTestEvent && this.state.cartMachineTestEvent.length > 0 && (
                              <thead style={{ fontWeight: 'bold' }}>
                                <tr className="bg-light">
                                  <th style={{ fontWeight: 'bold' }}>{t('home.Sr No')}</th>
                                  <th style={{ fontWeight: 'bold' }}>{t('home.TESTS')}</th>
                                  <th style={{ fontWeight: 'bold' }}>{t('home.LOCATION')}</th>
                                  <th style={{ fontWeight: 'bold' }}>{t('home.Qty')}</th>
                                  <th style={{ fontWeight: 'bold' }}>{t('home.Donation Contribution')}</th>
                                </tr>
                              </thead>
                            )}
                            <tbody style={{ fontWeight: 'bold' }}>
                              {this.state.cartMachineTestEvent && this.state.cartMachineTestEvent.map((infos, i) =>
                                infos.arr_cart.map((cella, ii) => (
                                  <tr key={`machinetest-${i}-${ii}`}>
                                    <td>{ii + 1}</td>
                                    <td>{cella.title}</td>
                                    <td>{cella.venue_address || t('home.Lonavla')}</td>
                                    <td>{(cella.parent * 1) + (cella.child * 1)}</td>
                                    <td>{t('home.INR')}&nbsp;{(cella.parent * cella.first_price) + (cella.child * cella.second_price)}</td>
                                  </tr>
                                ))
                              )}
                              {/* Total Row for Machine Tests */}
                              {(() => {
                                let total = 0;
                                if (this.state.cartMachineTestEvent && this.state.cartMachineTestEvent.length > 0) {
                                  this.state.cartMachineTestEvent.forEach(infos => {
                                    infos.arr_cart.forEach(cella => {
                                      total += (cella.parent * cella.first_price) + (cella.child * cella.second_price);
                                    });
                                  });
                                }
                                if (total > 0) {
                                  return (
                                    <tr style={{ background: '#f5f5f5' }}>
                                      <td colSpan={4} style={{ textAlign: 'right' }}>{t('home.Total')}</td>
                                      <td>{t('home.INR')}&nbsp;{total}</td>
                                    </tr>
                                  );
                                }
                                return null;
                              })()}
                            </tbody>

                          </table>

                          <table className="table table-bordered">


                            {cartEvent.map((info, i) => {
                              return (
                                <tbody>
                                  {/* <tr>
                                                <th colspan="12" style={{border:'none'}}>{t('home.Participants details for')} &nbsp; {info.event_type}</th>
                                            </tr> */}

                                  {info.arr_cart.map((cell, ii) => {
                                    return (
                                      <tbody>
                                        <tr className="bg-light">
                                          {/* <th colspan="4" style={{ width: '56%' }}>{t('home.STUDY COURSES')}</th> */}
                                          <th colspan="4" style={{ width: '56%' }}>{cell.event_type}</th>
                                          <th colspan="3">{t('home.LOCATION')}</th>
                                          {/* <th colspan="3">{t('home.Price')}</th> */}
                                          <th colspan="2">{t('home.Qty')}</th>
                                          {(() => {
                                            const parentUnits = cell.parent_units || cell.parent;
                                            const childUnits = cell.child_units || cell.child;
                                            const donationAmount = (parentUnits * cell.first_price) + (childUnits * cell.second_price);
                                            return donationAmount > 0 ? (
                                              <th colspan="3">{t('home.Donation Contribution')}</th>
                                            ) : null;
                                          })()}
                                        </tr>
                                        <tr className=" bg-extra-light">
                                          <th colspan="1">{i + 1}</th>
                                          <th colspan="3">{cell.title}</th>

                                          <th colspan="3">
                                            {cell.venue_address}
                                            {/* Show event date or date range for normal events (if available) */}
                                            {(() => {
                                              const rawStart = cell.start_date_format || cell.start_date || '';
                                              const rawEnd = cell.end_date_format || cell.end_date || '';
                                              const startFmt = this.formatDateForSchedule(rawStart);
                                              const endFmt = this.formatDateForSchedule(rawEnd);
                                              let dateRange = '';
                                              if (startFmt && endFmt) {
                                                if (startFmt === endFmt) dateRange = startFmt;
                                                else dateRange = `${startFmt} - ${endFmt}`;
                                              } else {
                                                dateRange = startFmt || endFmt || '';
                                              }
                                              return dateRange ? (<div className="text-muted" style={{fontSize: '0.9rem', marginTop: '6px'}}>{dateRange}</div>) : null;
                                            })()}
                                          </th>
                                          {/* <th colspan="3" style={{width:'16%'}}>
                                                    {t('home.INR')}&nbsp;{cell.first_price}/{cell.first_price_for}
                                        <br/>
                                        {t('home.INR')} &nbsp;{cell.second_price}/{cell.second_price_for}
                                                    </th> */}
                                          <th colspan="2" style={{ width: '16%' }}>{cell.parent * 1 + cell.child * 1}
                                          </th>
                                          {(() => {
                                            const parentUnits = cell.parent_units || cell.parent;
                                            const childUnits = cell.child_units || cell.child;
                                            const donationAmount = (parentUnits * cell.first_price) + (childUnits * cell.second_price);
                                            return donationAmount > 0 ? (
                                              <th colspan="3">
                                                {t('home.INR')}&nbsp;{donationAmount}
                                              </th>
                                            ) : null;
                                          })()}
                                        </tr>
                                        <tr>
                                          <th colspan="12">{t('home.Participants details for')} &nbsp; {cell.title}</th>
                                        </tr>

                                        <tr>
                                          <th colspan="1">{t('home.Sr No')}</th>
                                          <th colspan="1">{t('home.First Name')}<span className=" color-red">*</span></th>
                                          <th colspan="1">{t('home.Middle Name')}</th>
                                          <th colspan="1">{t('home.Last Name')}<span className=" color-red">*</span></th>
                                          <th colspan="1">{t('home.Date of Birth')}<span className=" color-red">*</span></th>
                                          <th colspan="1">{t('home.Age')}<span className=" color-red">*</span></th>
                                          <th colspan="1">{t('home.Gender')}<span className=" color-red">*</span></th>
                                          <th colspan="1">{t('home.Mobile')}<span className=" color-red">*</span></th>
                                          <th colspan="2">{t('home.Email')}<span className=" color-red">*</span></th>
                                          {/* <th>{t('home.Donation Contribution')}</th> */}
                                          <th colspan="2">{t('home.Address')}<span className=" color-red">*</span></th>
                                        </tr>

                                        {cell.arr_participants.map((cells, iii) => {
                                          if (cells.age >= 21) {
                                            return (
                                              <tr>
                                                <td colspan="1">{iii + 1}</td>
                                                <td colspan="1">{cells.first_name}</td>
                                                <td colspan="1">{cells.middle_name}</td>
                                                <td colspan="1">{cells.last_name}</td>
                                                <td colspan="1">{cells.date_of_birth}</td>
                                                <td colspan="1">{cells.age}</td>
                                                <td colspan="1">{cells.gender}</td>
                                                <td colspan="1">{cells.mobile || this.state.guestinfo.phone}</td>
                                                <td colspan="2">{cells.email || this.state.guestinfo.email}</td>
                                                {/* <td>
                                                                {t('home.INR')} {cells.first_price}/-
                                                                </td> */}
                                                <td colspan="2">{cells.address || [this.state.guestinfo.address_line_1, this.state.guestinfo.address_line_2].filter(Boolean).join(', ')}</td>
                                              </tr>

                                            )

                                          } else {
                                            return (
                                              <tr>
                                                <td colspan="1">{iii + 1}</td>
                                                <td colspan="1">{cells.first_name}</td>
                                                <td colspan="1">{cells.middle_name}</td>
                                                <td colspan="1">{cells.last_name}</td>
                                                <td colspan="1">{cells.date_of_birth}</td>
                                                <td colspan="1">{cells.age}</td>
                                                <td colspan="1">{cells.gender}</td>
                                                <td colspan="1">{cells.mobile || this.state.guestinfo.phone}</td>
                                                <td colspan="2">{cells.email || this.state.guestinfo.email}</td>
                                                {/* <td>
                                                                {t('home.INR')} {cells.second_price}/-
                                                                </td> */}
                                                <td colspan="2">{cells.address || [this.state.guestinfo.address_line_1, this.state.guestinfo.address_line_2].filter(Boolean).join(', ')}</td>
                                              </tr>
                                            )
                                          }
                                        })
                                        }

                                      </tbody>
                                    )
                                  })
                                  }

                                </tbody>
                              )
                            })
                            }

                          </table>

                          {/* Products Table - Only show if there are products */}
                          {cart.length > 0 && (
                          <table className="table table-bordered productTable">
                            <thead clas="productTableThead">

                              <tr>
                                <th colspan="12" style={{ border: 'none' }}>{t('home.Products')} </th>
                              </tr>
                              <tr className="bg-light">
                                <th colspan="2">{t('home.Sr No')}</th>
                                <th colspan="2">{t('home.Category')}</th>
                                <th colspan="2">{t('home.Product Name')}</th>
                                {/* <th colspan="3">{t('home.Trust')}</th> */}
                                <th colspan="2">{t('home.Author')}</th>
                                <th colspan="2">{t('home.Qty')}</th>
                                <th colspan="2">{t('home.Donation Contribution')}</th>
                              </tr>
                            </thead>

                            {cart.map((info, ii) => {
                              return (
                                <tbody>
                                  <tr className=" bg-extra-light" id={'TR' + info.product_id}>
                                    <th colspan="2">{ii + 1}</th>
                                    <th colspan="2">{info.type_name}</th>
                                    <th colspan="2">{info.title}</th>
                                    {/* <th colspan="3">{info.trust_name}</th> */}
                                    <th colspan="2">{info.author}</th>
                                    <th colspan="2">{info.quantity}</th>
                                    <th colspan="2">{t('home.INR')} {info.price}/-</th>
                                  </tr>
                                </tbody>
                              )

                            })
                            }

                            <tr className=" bg-extra-light" id="productTotalPrice">
                              <th colspan="8"></th>
                              <th colspan="2" style={{ textAlign: 'right' }}>{t('home.Total')}</th>
                              <th colspan="2" style={{ textAlign: 'right' }}>{t('home.INR')} {this.state.guestinfo.product_total_price}/-</th>
                            </tr>
                            <tbody>

                              {/* <thead  className="bg-light text-center" style={{display:'none'}}> */}
                              <tr id="noRecordsFoundTR" style={{ display: 'none', width: '140%' }}>
                                <th style={{ borderRight: 'none' }} colspan="12">
                                  {t('home.No Items in the Cart')}.
                                  <Link style={{ cursor: 'pointer', color: 'rgb(0, 123, 255)', borderRight: 'none' }} to={"/products"}>
                                    {t('home.Continue browsing')}
                                  </Link>
                                </th>


                              </tr>
                            </tbody>


                          </table>
                          )}

                          {/* Magazine Table - Only show if there are magazines */}
                          {arrMagazine.length > 0 && (
                          <table className="table table-sm table-bordered magazineTable">
                            <thead className="bg-light border-0" id="magazineItemThead">
                              <td className="border-0 font-weight-bold p-2 " colspan="6">{t('home.Magazine')}</td>

                            </thead>
                            <thead className="bg-light text-center" >
                              <tr>
                                <th>#</th>
                                <th scope="col"><span className="float-left d-inline-flex ">{t('home.Magazine')}</span>

                                  {/* <a className="float-right font-weight-normal" style={{cursor:'pointer',textDecoration:'underline',color:'#007bff'}}  onClick={this.goToMagazine}>{t('home.Click here to Add more Magazine')}</a> */}


                                </th>
                                <th scope="col">{t('home.Package')}</th>
                                <th scope="col">{t('home.Subscription')}</th>
                                <th scope="col">{t('home.Donation Contribution')}</th>

                                {/* <th scope="col">{t('home.Action')}</th> */}
                              </tr>
                            </thead>
                            <tbody>
                              {arrMagazine.map((info, iiiii) => {
                                return (

                                  <tr id={'MAGAZINETR' + info.package_id}>
                                    <td scope="row ">{iiiii + 1}</td>
                                    <td >
                                      {/* <Link to={"/magazine_details/"+info.magazine_id}>
                                        {info.magazine_title} <i className="fas fa-external-link-alt"></i>
                                        </Link> */}

                                      {info.magazine_title}

                                    </td>
                                    <td className="text-center">{info.package_title}</td>
                                    <td className="text-center">{info.subscription_type}</td>
                                    <td className="text-center">{t('home.INR')} {info.donation_contribution}/-
                                      {/* {guestinfo.totalMagazinePrice}{'magazinetotal'+magazineTotal}{'default'+totalMagazinePrice} */}
                                    </td>

                                    {/* <td className="text-center" ><i name={info.package_id} id={info.package_id} onClick={this.removeMagazineFromCart} className="fa fa-trash-alt" style={{cursor:'pointer'}} ></i></td> */}
                                  </tr>

                                )
                              })
                              }
                              <tr className=" bg-extra-light" >
                                <th colspan="3"></th>
                                <th style={{ textAlign: 'right' }}>{t('home.Total')}</th>
                                <th style={{ textAlign: 'right' }}>{t('home.INR')}
                                  {/* {magazineinfo.totalMagazinePrice} */}
                                  {arrMagazine.map((infos, iiiiv) => {
                                    if (iiiiv == 0) {
                                      return (
                                        <span>
                                          {infos.total_donation_contribution}
                                        </span>
                                      )
                                    }

                                  })
                                  }
                                  {/* {magazineinfo.totalMagazinePrice} */}
                                  {/* {this.getTotal()} */}
                                  /-</th>
                              </tr>
                            </tbody>
                          </table>
                          )}

                        </div>

                        {/* Mobile Design */}
                        <div className="d-xl-none d-lg-none  d-inline-block px-3">

                          {/* Machine Test */}
                          {cartMachineTestEvent.map((infos, i) =>
                            <Row key={infos.event_type_id} className="">
                              <Col sm="12" xs="12" className="bg-light py-2">
                                <h6>
                                  {infos.event_type}
                                </h6>
                              </Col>
                              <Col sm="12" xs="12">
                                {infos.arr_cart.map((cella) =>
                                  <Row className="border-bottom">
                                    <Col sm="12" xs="12" className="font-weight-bold py-2">
                                      {cella.title}
                                    </Col>
                                    <Col sm="12" xs="12">
                                      <Label className="font-weight-bold">
                                        {t('home.LOCATION')}&nbsp;:&nbsp;
                                      </Label>
                                      <Label>
                                        {t('home.Lonavla')}
                                      </Label>
                                    </Col>

                                    <Col sm="12" xs="12" >
                                      <Label className="font-weight-bold">
                                        {t('home.Qty')}&nbsp;:&nbsp;
                                      </Label>
                                      <Label>
                                        {cella.parent * 1 + cella.child * 1}
                                      </Label>
                                    </Col>
                                    {(() => {
                                      // Calculate donation using units (for couple pricing)
                                      const parentUnits = cella.parent_units || cella.parent;
                                      const childUnits = cella.child_units || cella.child;
                                      const donationAmount = (parentUnits * cella.first_price) + (childUnits * cella.second_price);
                                      
                                      return donationAmount > 0 ? (
                                        <Col sm="12" xs="12">
                                          <Label className="font-weight-bold">
                                            {t('home.Donation Contribution')}&nbsp;:&nbsp;
                                          </Label>
                                          <Label>
                                            {t('home.INR')}&nbsp;{donationAmount}
                                          </Label>
                                        </Col>
                                      ) : null;
                                    })()}

                                    <Col sm="12" xs="12" className="font-weight-bold">
                                      Participants
                                    </Col>
                                    {
                                      cella.arr_participants.map((cellss, iii) =>
                                        <Col sm="12" xs="12" keys={cellss.participant_id} className="py-2 border-bottom">
                                          <Row>
                                            <Col sm="12" xs="12">
                                              <Label className="font-weight-bold">
                                                {t('home.First Name')}&nbsp;:&nbsp;
                                              </Label>
                                              <Label>
                                                {cellss.first_name}&nbsp;
                                              </Label>
                                            </Col>
                                            <Col sm="12" xs="12">
                                              <Label className="font-weight-bold">
                                                {t('home.Middle Name')}&nbsp;:&nbsp;
                                              </Label>
                                              <Label>
                                                {cellss.middle_name}&nbsp;
                                              </Label>
                                            </Col>
                                            <Col sm="12" xs="12">
                                              <Label className="font-weight-bold">
                                                {t('home.Last Name')}&nbsp;:&nbsp;
                                              </Label>
                                              <Label>
                                                {cellss.last_name}&nbsp;
                                              </Label>
                                            </Col>
                                            <Col sm="12" xs="12">
                                              <Label className="font-weight-bold">
                                                {t('home.Date of Birth')}&nbsp;:&nbsp;
                                              </Label>
                                              <Label>
                                                {cellss.date_of_birth}
                                              </Label>
                                            </Col>
                                            <Col sm="12" xs="12">
                                              <Label className="font-weight-bold">
                                                {t('home.Age')}&nbsp;:&nbsp;
                                              </Label>
                                              <Label>
                                                {cellss.age}
                                              </Label>
                                            </Col>
                                            <Col sm="12" xs="12">
                                              <Label className="font-weight-bold">
                                                {t('home.Gender')}&nbsp;:&nbsp;
                                              </Label>
                                              <Label>
                                                {cellss.gender}
                                              </Label>
                                            </Col>
                                            <Col sm="12" xs="12">
                                              <Label className="font-weight-bold">
                                                {t('home.Mobile')}&nbsp;:&nbsp;
                                              </Label>
                                              <Label>
                                                {cellss.mobile || this.state.guestinfo.phone}
                                              </Label>
                                            </Col>
                                            <Col sm="12" xs="12">
                                              <Label className="font-weight-bold">
                                                {t('home.Email')}&nbsp;:&nbsp;
                                              </Label>
                                              <Label>
                                                {cellss.email || this.state.guestinfo.email}
                                              </Label>
                                            </Col>
                                            <Col sm="12" xs="12">
                                              <Label className="font-weight-bold">
                                                {t('home.Address')}&nbsp;:&nbsp;
                                              </Label>
                                              <Label>
                                                {cellss.address || [this.state.guestinfo.address_line_1, this.state.guestinfo.address_line_2].filter(Boolean).join(', ')}
                                              </Label>
                                            </Col>
                                          </Row>

                                        </Col>

                                      )
                                    }
                                  </Row>
                                )
                                }
                              </Col>
                            </Row>

                          )
                          }

                          {/* Events */}
                          {cartEvent.map((infos, i) =>
                            <Row key={infos.event_type_id} className="">
                              <Col sm="12" xs="12" className="bg-light py-2">
                                <h6>
                                  {infos.event_type}
                                </h6>
                              </Col>
                              <Col sm="12" xs="12">
                                {infos.arr_cart.map((cella) =>
                                  <Row className="border-bottom">
                                    <Col sm="12" xs="12" className="font-weight-bold py-2">
                                      {cella.title}
                                    </Col>
                                    <Col sm="12" xs="12">
                                      <Label className="font-weight-bold">
                                        {t('home.LOCATION')}&nbsp;:&nbsp;
                                      </Label>
                                      <Label>
                                        {cella.venue_address}
                                      </Label>
                                    </Col>
                                    {(() => {
                                      const rawStart = cella.start_date_format || cella.start_date || '';
                                      const rawEnd = cella.end_date_format || cella.end_date || '';
                                      const startFmt = this.formatDateForSchedule(rawStart);
                                      const endFmt = this.formatDateForSchedule(rawEnd);
                                      let dateRange = '';
                                      if (startFmt && endFmt) {
                                        if (startFmt === endFmt) dateRange = startFmt;
                                        else dateRange = `${startFmt} - ${endFmt}`;
                                      } else {
                                        dateRange = startFmt || endFmt || '';
                                      }
                                      return dateRange ? (
                                        <Col sm="12" xs="12">
                                          <Label className="font-weight-bold">
                                            {t('home.Date')}&nbsp;:&nbsp;
                                          </Label>
                                          <Label>
                                            {dateRange}
                                          </Label>
                                        </Col>
                                      ) : null;
                                    })()}
                                    <Col sm="12" xs="12" >
                                      <Label className="font-weight-bold">
                                        {t('home.Qty')}&nbsp;:&nbsp;
                                      </Label>
                                      <Label>
                                        {cella.parent * 1 + cella.child * 1}
                                      </Label>
                                    </Col>
                                    {((cella.parent * cella.first_price) + (cella.child * cella.second_price)) > 0 && (
                                      <Col sm="12" xs="12">
                                        <Label className="font-weight-bold">
                                          {t('home.Donation Contribution')}&nbsp;:&nbsp;
                                        </Label>
                                        <Label>
                                          {t('home.INR')}&nbsp;{(cella.parent * cella.first_price) + (cella.child * cella.second_price)}
                                        </Label>
                                      </Col>
                                    )}

                                    <Col sm="12" xs="12" className="font-weight-bold">
                                      Participants
                                    </Col>
                                    {
                                      cella.arr_participants.map((cellss, iii) =>
                                        <Col sm="12" xs="12" keys={cellss.participant_id} className="py-2">
                                          {cellss.first_name}&nbsp;
                                          {cellss.middle_name}&nbsp;
                                          {cellss.last_name}&nbsp;
                                          <Row>
                                            <Col sm="12" xs="12">
                                              <Label className="font-weight-bold">{t('home.Mobile')}&nbsp;:&nbsp;</Label>
                                              <Label>{cellss.mobile || this.state.guestinfo.phone}</Label>
                                            </Col>
                                            <Col sm="12" xs="12">
                                              <Label className="font-weight-bold">{t('home.Email')}&nbsp;:&nbsp;</Label>
                                              <Label>{cellss.email || this.state.guestinfo.email}</Label>
                                            </Col>
                                            <Col sm="12" xs="12">
                                              <Label className="font-weight-bold">{t('home.Address')}&nbsp;:&nbsp;</Label>
                                              <Label>{cellss.address || [this.state.guestinfo.address_line_1, this.state.guestinfo.address_line_2].filter(Boolean).join(', ')}</Label>
                                            </Col>
                                          </Row>
                                        </Col>

                                      )
                                    }
                                  </Row>
                                )
                                }
                              </Col>
                            </Row>
                          )
                          }

                          {/* Products */}
                          {cart.length ? <Row>
                            <Col sm="12" xs="12" className="bg-light py-2">
                              <h6>
                                Products
                              </h6>
                            </Col>
                            {cart.map((info, i) =>
                              <Col sm="12" xs="12" className="">
                                <Row className="border-bottom">
                                  <Col sm="12" xs="12" className="font-weight-bold py-2">
                                    {info.title}
                                  </Col>
                                  <Col sm="12" xs="12">
                                    <Label className="font-weight-bold">
                                      {t('home.Category')}&nbsp;:&nbsp;
                                    </Label>
                                    <Label>
                                      {info.type_name}
                                    </Label>
                                  </Col>
                                  <Col sm="12" xs="12" >
                                    <Label className="font-weight-bold">
                                      {t('home.Qty')}&nbsp;:&nbsp;
                                    </Label>
                                    <Label>
                                      {info.quantity}
                                    </Label>
                                  </Col>
                                  <Col sm="12" xs="12" >
                                    <Label className="font-weight-bold">
                                      {t('home.Author')}&nbsp;:&nbsp;
                                    </Label>
                                    <Label>
                                      {info.author}
                                    </Label>
                                  </Col>
                                  <Col sm="12" xs="12" >
                                    <Label className="font-weight-bold">
                                      {t('home.Donation Contribution')}&nbsp;:&nbsp;
                                    </Label>
                                    <Label>
                                      {t('home.INR')} {info.price}/-
                                    </Label>
                                  </Col>

                                </Row>
                              </Col>

                            )
                            }
                          </Row> : (null)
                          }

                          {/* Magazine */}
                          {arrMagazine.length ? <Row>
                            <Col sm="12" xs="12" className="bg-light py-2">
                              <h6>
                                {t('home.Magazine')}
                              </h6>
                            </Col>
                            {arrMagazine.map((info, i) =>
                              <Col sm="12" xs="12" className="">
                                <Row className="border-bottom">
                                  <Col sm="12" xs="12" className="font-weight-bold py-2">
                                    {info.magazine_title}
                                  </Col>
                                  <Col sm="12" xs="12">
                                    <Label className="font-weight-bold">
                                      {t('home.Package')}&nbsp;:&nbsp;
                                    </Label>
                                    <Label>
                                      {info.package_title}
                                    </Label>
                                  </Col>
                                  <Col sm="12" xs="12" >
                                    <Label className="font-weight-bold">
                                      {t('home.Subscription')}&nbsp;:&nbsp;
                                    </Label>
                                    <Label>
                                      {info.subscription_type}
                                    </Label>
                                  </Col>
                                  <Col sm="12" xs="12" >
                                    <Label className="font-weight-bold">
                                      {t('home.Donation Contribution')}&nbsp;:&nbsp;
                                    </Label>
                                    <Label>
                                      {t('home.INR')} {info.donation_contribution}/-
                                    </Label>
                                  </Col>

                                </Row>
                              </Col>

                            )
                            }
                          </Row> : (null)
                          }
                        </div>
                      </div>
                    </div>
                    <div className="card my-3">
                      <div className="card-header bg-dark-grey-old collapsed" id="headingTwo" aria-expanded="false" aria-controls="collapseTwo">
                        <h5 className="mb-0">
                          {t('home.BILLING & SHIPPING ADDRESS')}
                        </h5>
                        {/* <span  style={{fontSize: '11px',background: 'white', padding: '0px 6px', borderRadius: '54%', marginTop: '-17px', marginLeft: '94%', position: 'absolute'}}>
                                    <div className="arrow-down" style={{width:'0px',height:'0px',borderLeft:'6px solid transparent',borderRight:'6px solid transparent',borderTop:'8px solid #9d0b0e',marginTop:'6px',marginBottom:'3px'}}></div>
                                    </span> */}

                        <img
                          onClick={this.changeArrowDirection}
                          id="arrowTwo"
                          style={{ height: '20px', width: '20px', float: 'right', marginTop: '-20px', cursor: 'pointer' }} className="image_main_carosal" src={checkoutImage} data-toggle="collapse" data-target="#collapseTwo" />

                      </div>
                      <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                        <div className="card-body">
                          <div className="row">
                            {guestinfoarray.map((info, ii) => {
                              return (
                                <div className="col-12 col-lg-6 border-right">
                                  <h5 className="modal-title mb-3" id="exampleModalLabel">{t('home.BILLING ADDRESS')}</h5>

                                  <div className="row">
                                    <div className="form-group col-12 col-md-4">
                                      <label className="color-black font-weight-bolder">{t('home.First Name')}<span className="color-red">*</span></label>
                                      <input type="text" className="form-control form-control-sm display-input" value={info.first_name} disabled />
                                    </div>
                                    <div className="form-group col-12 col-md-4">
                                      <label className="color-black font-weight-bolder">{t('home.Middle Name')}</label>
                                      <input type="text" className="form-control form-control-sm display-input" value={info.middle_name} disabled />
                                    </div>
                                    <div className="form-group col-12 col-md-4">
                                      <label className="color-black font-weight-bolder">{t('home.Last Name')}<span className="color-red">*</span></label>
                                      <input type="text" className="form-control form-control-sm display-input" value={info.last_name} disabled />
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="form-group col-12 col-md-12">
                                      <label className="color-black font-weight-bolder">{t('home.Company / Institution / Organization Name')}</label>
                                      <input type="text" className="form-control form-control-sm display-input" value={info.company} disabled />
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="form-group col-12 col-md-6">
                                      <label className="color-black font-weight-bolder">{t('home.Address Line 1')}<span className="color-red">*</span></label>
                                      <input type="text" className="form-control form-control-sm display-input" value={info.address_line_1} disabled />
                                    </div>
                                    <div className="form-group col-12 col-md-6">
                                      <label className="color-black font-weight-bolder">{t('home.Address Line 2')}</label>
                                      <input type="text" className="form-control form-control-sm display-input" value={info.address_line_2} disabled />
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="form-group col-12 col-md-12">
                                      <label className="color-black font-weight-bolder">{t('home.Landmark')}</label>
                                      <input type="text" className="form-control form-control-sm display-input" value={info.landmark} disabled />
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="form-group col-12 col-md-6">
                                      <label className="color-black font-weight-bolder">{t('home.City')}<span className="color-red">*</span></label>
                                      <input type="text" className="form-control form-control-sm display-input" value={info.city_name || ''} disabled />
                                    </div>
                                    <div className="form-group col-12 col-md-6">
                                      <label className="color-black font-weight-bolder">{t('home.State / Province')}<span className="color-red">*</span></label>
                                      <input type="text" className="form-control form-control-sm display-input" value={info.state_name || ''} disabled />
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="form-group col-12 col-md-6">
                                      <label className="color-black font-weight-bolder">{t('home.Country')}<span className="color-red">*</span></label>
                                      <input type="text" className="form-control form-control-sm display-input" value={info.country_name || ''} disabled />
                                    </div>
                                    <div className="form-group col-12 col-md-6">
                                      <label className="color-black font-weight-bolder">{t('home.Pincode')}<span className="color-red">*</span></label>
                                      <input type="text" className="form-control form-control-sm display-input" value={info.pincode} disabled />
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="form-group col-12 col-md-6">
                                      <label className="color-black font-weight-bolder">{t('home.Phone')}<span className="color-red">*</span></label>
                                      <input type="text" className="form-control form-control-sm display-input" value={info.phone} disabled />
                                    </div>
                                    <div className="form-group col-12 col-md-6">
                                      <label className="color-black font-weight-bolder">{t('home.Email')}<span className="color-red">*</span></label>
                                      <input type="text" className="form-control form-control-sm display-input" value={info.email} disabled />
                                    </div>
                                  </div>

                                </div>
                              )
                            })
                            }
                            {( (this.state.cart && this.state.cart.length > 0) || (this.state.arrMagazine && this.state.arrMagazine.length > 0) ) ? (
                              <div className="col-12 col-lg-6">
                                <div className="row">
                                <div className="col-lg-6">
                                  <h5 className="modal-title mb-3" id="exampleModalLabel">{t('home.SHIPPING ADDRESS')}</h5>
                                </div>
                                {/* <div className="col-lg-8">
                                                        <div className="form-group form-check pl-0 pt-1">
                                                            <div className="custom-control custom-checkbox">
                                                                <input type="checkbox" className="custom-control-input form-control-sm" id="customCheck1" name="example1" />
                                                                <label className="custom-control-label remember-me" for="customCheck1">{t('home.Same as Billing Address')}</label>
                                                            </div>
                                                        </div>
                                                    </div> */}
                              </div>
                                {eventinfoarray.map((infoss, ii) => {
                                return (
                                  <div>
                                    <div className="row">
                                      <div className="form-group col-12 col-md-4">
                                        <label className="color-black font-weight-bolder">{t('home.First Name')}<span className="color-red">*</span></label>
                                        <input type="text" className="form-control form-control-sm display-input" value={infoss.first_name} disabled />
                                      </div>
                                      <div className="form-group col-12 col-md-4">
                                        <label className="color-black font-weight-bolder">{t('home.Middle Name')}</label>
                                        <input type="text" className="form-control form-control-sm display-input" value={infoss.middle_name} disabled />
                                      </div>
                                      <div className="form-group col-12 col-md-4">
                                        <label className="color-black font-weight-bolder">{t('home.Last Name')}<span className="color-red">*</span></label>
                                        <input type="text" className="form-control form-control-sm display-input" value={infoss.last_name} disabled />
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="form-group col-12 col-md-12">
                                        <label className="color-black font-weight-bolder">{t('home.Company / Institution / Organization Name')}</label>
                                        <input type="text" className="form-control form-control-sm display-input" value={infoss.company} disabled />
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="form-group col-12 col-md-6">
                                        <label className="color-black font-weight-bolder">{t('home.Address Line 1')}<span className="color-red">*</span></label>
                                        <input type="text" className="form-control form-control-sm display-input" value={infoss.address_line_1} disabled />
                                      </div>
                                      <div className="form-group col-12 col-md-6">
                                        <label className="color-black font-weight-bolder">{t('home.Address Line 2')}</label>
                                        <input type="text" className="form-control form-control-sm display-input" value={infoss.address_line_2} disabled />
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="form-group col-12 col-md-12">
                                        <label className="color-black font-weight-bolder">{t('home.Landmark')}</label>
                                        <input type="text" className="form-control form-control-sm display-input" value={infoss.landmark} disabled />
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="form-group col-12 col-md-6">
                                        <label className="color-black font-weight-bolder">{t('home.City')}<span className="color-red">*</span></label>
                                        <input type="text" className="form-control form-control-sm display-input" value={infoss.city_name || ''} disabled />
                                      </div>
                                      <div className="form-group col-12 col-md-6">
                                        <label className="color-black font-weight-bolder">{t('home.State / Province')}<span className="color-red">*</span></label>
                                        <input type="text" className="form-control form-control-sm display-input" value={infoss.state_name || ''} disabled />
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="form-group col-12 col-md-6">
                                        <label className="color-black font-weight-bolder">{t('home.Country')}<span className="color-red">*</span></label>
                                        <input type="text" className="form-control form-control-sm display-input" value={infoss.country_name || ''} disabled />
                                      </div>
                                      <div className="form-group col-12 col-md-6">
                                        <label className="color-black font-weight-bolder">{t('home.Pincode')}<span className="color-red">*</span></label>
                                        <input type="text" className="form-control form-control-sm display-input" value={infoss.pincode} disabled />
                                      </div>
                                    </div>
                                    <div className="row">
                                      <div className="form-group col-12 col-md-6">
                                        <label className="color-black font-weight-bolder">{t('home.Phone')}<span className="color-red">*</span></label>

                                        <input type="text" className="form-control form-control-sm display-input" value={infoss.phone} disabled />
                                      </div>
                                      <div className="form-group col-12 col-md-6">
                                        <label className="color-black font-weight-bolder">{t('home.Email')}<span className="color-red">*</span></label>
                                        <input type="text" className="form-control form-control-sm display-input" value={infoss.email} disabled />
                                      </div>
                                    </div>
                                  </div>
                                )
                                })
                                }
                              </div>
                            ) : null }
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card my-3">
                      <div className="card-header bg-dark-grey-old collapsed" id="headingThree" aria-expanded="true" aria-controls="collapseThree">
                        <h5 className="mb-0">
                          {t('home.SHIPPING CHARGES')}
                        </h5>
                        <img
                          id="arrowThree"
                          style={{ height: '20px', width: '20px', float: 'right', marginTop: '-20px', cursor: 'pointer' }}
                          className={cart.length || arrMagazine.length ? "image_main_carosal rotate180" : "image_main_carosal"}
                          src={checkoutImage} data-toggle="collapse" data-target="#collapseThree" onClick={this.changeArrowDirection} />
                      </div>
                      <div id="collapseThree" className={cart.length || arrMagazine.length ? "collapse show" : "collapse"} aria-labelledby="headingThree" data-parent="#accordion">
                        {cart.map((info, iiiiiii) => {
                          if (iiiiiii == 0) {
                            if (this.state.guestinfo.total_weight_in_kg > 0 && this.state.guestinfo.total_weight_in_kg != undefined) {
                              return (
                                <div className="card-body">
                                  <div className="row">
                                    <div className="col-12" id="RegularTypeDiv"> <input style={{ width: '28px', height: '16px' }} type="radio" id="delivery_type" name="delivery_type" value="1"
                                      checked={this.state.delivery_type == 1}
                                      onChange={this.handleChangeDelivery}
                                    />
                                      {t('home.Regular')} &nbsp;
                                      {this.state.guestinfo.total_weight_in_kg}
                                      &nbsp;{t('home.kg in')} &nbsp;

                                      {/* {guestinfo.country_name} */}
                                      <strong id="allShippingCharges" style={{ fontSize: '1.25rem' }}>
                                        {t('home.INR')} {this.state.guestinfo.total_shipping_charges}/-

                                        {this.state.guestinfo.shipping_message}


                                        <label style={{ fontSize: '1.25rem', display: 'none' }} id="noShippingCharges">
                                          {t('home.No shipping charges.')}
                                        </label>
                                      </strong>

                                    </div>
                                    {/* <div className="col-6 text-right">


                                                    </div>
                                                    */}
                                  </div>

                                  <div className="row" id="total_shipping_charges_express_row" style={{ display: 'none' }}>
                                    <div className="col-12"> <input style={{ width: '28px', height: '16px' }} type="radio" id="delivery_type" name="delivery_type" value="2"
                                      checked={this.state.delivery_type == 2}
                                      onChange={this.handleChangeDelivery}
                                    />
                                      {t('home.Express')} &nbsp;

                                      {this.state.guestinfo.total_weight_in_kg}
                                      &nbsp;{t('home.kg in')} &nbsp;
                                      {/*  {this.state.guestinfo.country_name} */}

                                      <strong style={{ fontSize: '1.25rem' }}> {t('home.INR')}

                                        {this.state.guestinfo.total_shipping_charges_express}/-


                                        {this.state.guestinfo.shipping_message}
                                      </strong>

                                    </div>
                                    {/* <div className="col-6 text-right">
                                                          <h5>
                                                        {t('home.INR')}

                                                        {this.state.guestinfo.total_shipping_charges_express}/-
                                                        <br/>

                                                        {this.state.guestinfo.shipping_message}

                                                            </h5>

                                                    </div> */}
                                  </div>
                                </div>
                              )
                            } else {
                              return (
                                <div className="card-body">
                                  <div className="row">
                                    <div className="col-6" id="RegularTypeDiv"> <input style={{ width: '28px', height: '16px' }} type="radio" id="delivery_type" name="delivery_type" value="1"
                                      checked={this.state.delivery_type == 1}
                                      onChange={this.handleChangeDelivery}
                                    />
                                      {t('home.Regular')} &nbsp;
                                      {info.total_weight_in_kg} &nbsp;{t('home.kg in')} &nbsp; {info.country_name}
                                    </div>
                                    <div className="col-6 text-right">
                                      <h5 id="allShippingCharges">
                                        {t('home.INR')} {info.total_shipping_charges}/-
                                        <br />
                                        {info.shipping_message}

                                      </h5>
                                      <h5 id="noShippingCharges" style={{ display: 'none' }}>
                                        {t('home.No shipping charges.')}
                                      </h5>

                                    </div>
                                  </div>

                                  <div className="row" id="total_shipping_charges_express_row" style={{ display: 'none' }}>
                                    <div className="col-6"> <input style={{ width: '28px', height: '16px' }} type="radio" id="delivery_type" name="delivery_type" value="2"
                                      checked={this.state.delivery_type == 2}
                                      onChange={this.handleChangeDelivery}
                                    />
                                      {t('home.Express')} &nbsp;
                                      {info.total_weight_in_kg}
                                      &nbsp;{t('home.kg in')} &nbsp;
                                      {info.country_name}
                                    </div>
                                    <div className="col-6 text-right">
                                      <h5>
                                        {t('home.INR')}

                                        {info.total_shipping_charges_express}/-
                                        <br />

                                        {info.shipping_message}

                                      </h5>
                                    </div>
                                  </div>
                                </div>
                              )
                            }
                          }
                        })
                        }
                        <div className="col-12 text-right" id="noShippingChargesEventOnly">

                          <h5 id="noShippingChargesMessage" >
                            {t('home.No shipping charges.')}
                          </h5>

                        </div>
                      </div>
                    </div>
                    <div className="card my-3">
                      <div className="card-header bg-dark-grey-old collapsed" id="headingFour" aria-expanded="false" aria-controls="collapseFour">
                        <h5 className="mb-0 totalIncludingShippingChargesClass">
                          {(
                            this.state.bookingEvent &&
                            (this.state.bookingEvent.event_type === 'Machine Test' || this.state.bookingEvent.event_type_id === 3)
                          ) || this.state.cart.length > 0 || this.state.arrMagazine.length > 0
                            ? t('home.TOTAL (Including Shipping Charges)')
                            : 'TOTAL'
                          }
                        </h5>
                        {/* <span  style={{fontSize: '11px',background: 'white', padding: '0px 6px', borderRadius: '54%', marginTop: '-17px', marginLeft: '94%', position: 'absolute'}}>
                                    <div className="arrow-down" style={{width:'0px',height:'0px',borderLeft:'6px solid transparent',borderRight:'6px solid transparent',borderTop:'8px solid #9d0b0e',marginTop:'6px',marginBottom:'3px'}}></div>
                                    </span> */}
                        <img
                          onClick={this.changeArrowDirection}
                          id="arrowFour"
                          style={{ height: '20px', width: '20px', float: 'right', marginTop: '-20px', cursor: 'pointer' }}
                          className={cart.length === 0 && arrMagazine.length == 0 ? "image_main_carosal rotate180" : "image_main_carosal"}
                          src={checkoutImage} data-toggle="collapse" data-target="#collapseFour" />

                      </div>
                      <div id="collapseFour" className={cart.length === 0 && arrMagazine.length == 0 ? "collapse show" : "collapse"} aria-labelledby="headingFour" data-parent="#accordion">
                        <div className="card-body">
                          <div className="row">
                            <div className="col-6">
                              {/*  * {t('home.Service Charges will be added on Payment page')}.
                                      */}

                            </div>
                            <div className="col-6 text-right">
                              <h5>{t('home.INR')}
                                {eventinfo.cart_total_price}
                                {/* {this.cartTotalPrice()} */}
                                {/* {ship_charg_value} */}
                                /-</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card my-3 d-none">
                      <div className="card-header bg-dark-grey-old collapsed" id="headingSix" data-toggle="collapse" data-target="#collapseSix6" aria-expanded="false" aria-controls="collapseSix6">
                        <h5 className="mb-0">
                          {/* <a  target="_blank" href={myConstClass.BASE_URL+'terms/termsConditionsPDF/'+this.state.language}> */}
                          <a target="_blank" href={myConstClass.IMAGE_URL + 'invoices/' + this.state.languagePdf}>
                            {t('home.TERMS & CONDITIONS')}
                          </a>
                        </h5>
                        {/* <span  style={{fontSize: '11px',background: 'white', padding: '0px 6px', borderRadius: '54%', marginTop: '-17px', marginLeft: '94%', position: 'absolute'}}>
                                                  <div className="arrow-down" style={{width:'0px',height:'0px',borderLeft:'6px solid transparent',borderRight:'6px solid transparent',borderTop:'8px solid #9d0b0e',marginTop:'6px',marginBottom:'3px'}}></div>
                                                </span>
                                                <img style={{ height: '20px', width: '20px', float: 'right', marginTop: '-20px', cursor: 'pointer' }} className="image_main_carosal" src={checkoutImage} /> */}

                      </div>

                      <div id="collapseSix" className="collapse" aria-labelledby="headingSix" data-parent="#accordion">
                        <div className="card-body">
                          <div className="row" style={{ marginTop: '-10px' }}>
                            <div className="col-12">
                              <div className="form-group">
                                {termsinfo.title}<br />
                                {ReactHtmlParser(termsinfo.description)}
                                {/* <label for="exampleFormControlTextarea1">{t('home.Use this area for special instructions or questions regarding your order')}</label> */}

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <form id="captcha" name="captcha">
                      <div className="row">
                        <div className="col">
                          <div className="border p-3">
                            
                            <ReCAPTCHA
                              ref={this.recaptchaRef}
                              sitekey="6Lczr9EUAAAAAGrmJxhRbIE2F4gvajaG1dxu8gQM"
                              theme="light"
                              onChange={this.onRecaptchaChange}
                            />

                          </div>
                        </div>
                      </div>
                    </form>
                    <div className="row my-3">
                      <div className="col-xl-3 col-lg-3 col-md-3 col-12">
                        <button
                          id="btn_click"
                          name="btn_click"
                          className="btn btn-sm btn-brown btn-block"
                          onClick={this.proceedToPayment}
                          disabled={
                            this.state.isProcessingPayment ||
                            !this.state.recaptchaToken ||
                            typeof this.state.recaptchaToken !== 'string' ||
                            this.state.recaptchaToken.length < 10
                          }
                        >
                          {this.state.isProcessingPayment
                            ? t('home.PROCESSING')
                            : t('home.PROCEED TO PAYMENT')}
                        </button>
                        {/* <img style={{ display: 'none' }} id="loader" name="loader" src={myConstClass.IMAGE_URL + 'loader.gif'} className="img-fluid" /> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <form method="post" id="redirect" name="redirect" action="https://secure.ccavenue.com/transaction/transaction.do?command=initiateTransaction">
            <input type='hidden' name='encRequest' value={removeinfo.encrypted_data || ''} />
            <input type='hidden' name='access_code' value={removeinfo.access_code || ''} />
            <input type="submit" name="btn_submit" id="btn_submit" style={{ display: 'none' }} />
          </form>

        </div>
        <Footer />
      </div>
    );
  }
}
Checkout.propTypes = {
  t: PropTypes.func.isRequired,
};
export default translate(Checkout);